import React from "react";
import { useState, useEffect, useCallback, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import { Link, useHistory } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { useLocation } from 'react-router-dom';


import {
  playerlistData,
  teamlistData,
  setisfirsttime,
  playerfilter,
  actmore,
} from "../../actions/index";
import { encode } from "base-64";
import {
  auctiondefaultLogo,
  bgtop1,
  teamdefaultLogo,
  toplprofile,
} from "../../constants/Images";
import { tele } from "../../constants/Images";
import { mask } from "../../constants/Images";
import { plbg } from "../../constants/Images";
import { ribbin } from "../../constants/Images";
import { whitebg } from "../../constants/Images";
import { soldstamp } from "../../constants/Images";
import { pdfauctiontitlebg } from "../../constants/Images";
import { ribbin3, ribbin2, tagbadge } from "../../constants/Images";
// import { ribbin3 } from "../../constants/Images";
import { topborderirng, pdflayout1, pdflayout2 } from "../../constants/Images";
import { ribinfo } from "../../constants/Images";
import { BASE_PATH } from "../../constants/Global";
import { sp1 } from "../../constants/Images";
import { TiUserDelete } from "react-icons/ti";
import { useReactToPrint } from "react-to-print";
// import { PDFDownloadLink, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import "./NotoSansGujarati-Regular-normal.js";

// import * as fontkit from 'fontkit'; // Import all exports
// import html2pdf from 'html2pdf.js/html2pdf';

import { confirmAlert } from "react-confirm-alert";
import { playerdefaultLogo } from "../../constants/Images";
import { getAge } from "../../Helpers/Helpers";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import jsPDF from "jspdf";
import { pdfbg, top2bg, rankbadge, pdfbgcustom1 } from "../../constants/Images";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faC, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
// import { useHistory } from 'react-router-dom';
import * as XLSX from "xlsx";
import axios from "axios";
import html2canvas from "html2canvas";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  push,
  update,
} from "firebase/database";
import { FirebaseContext } from "../../FirebaseContext";
import { actlistData } from "../../actions/index";
// import { color } from "html2canvas/dist/types/css/types/color";

function Players(match) {
  const reportTemplateRef = useRef(null);

  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [currentauc, setcurrentauc] = useState([]);
  const [pldata, setplData] = useState([]);
  const [dataTeam, setTeamData] = useState([]);
  const [isActive, setActive] = useState(false);
  const [isbase64Loading, setIsbase64Loading] = useState(false);
  const [isspnshow, setisspnshow] = useState(false);
  const getpageData = useSelector((state) => state.setplayerlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const getteampageData = useSelector((state) => state.setteamlistData);
  const getcatpageData = useSelector((state) => state.setcatlistData);
  const getfilters = useSelector((state) => state.setplfilters);

  const [admin_id, setadminid] = useState(localStorage.getItem("admin_id"));
  const [admin_name, setadmin_name] = useState(
    localStorage.getItem("admin_name")
  );

  const aucdatalist = useSelector((state) => state.setactlistData);

  const aid = localStorage.getItem("auction_id");
  const acname = localStorage.getItem("auction_name");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedpllist, setselectedpllist] = useState([]);

  const [cid, setCid] = useState(loginuser["cid"]);
  const [pdfclk, setpdfclk] = useState(false);
  const [isexcelclk, setisexcelclk] = useState(false);
  const [orderby, setorderby] = useState("");
  const [orderby2, setorderby2] = useState("");
  const [exceltype, setexceltype] = useState("");
  const [colno, setcolno] = useState("");
  const [numofpl, setnumofpl] = useState("");
  const [plcat, setplcat] = useState("");
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const [sts, setsts] = useState("");
  const [catdata, setcatData] = useState("");
  const [filorder, setfilorder] = useState("");
  const [issetdata, setissetdata] = useState(false);
  const [isbulkdelenable, setisbulkdelenable] = useState(false);
  const [isplnoshow, setisplnoshow] = useState(true);
  const [ismobnoshow, setismobnoshow] = useState(false);
  const [istshirtshow, setistshirtshow] = useState(false);
  const [ispointsshow, setispointsshow] = useState(true);
  const [isdetailshow, setisdetailshow] = useState(false);
  const [isbasePriceShow, setisbasePriceShow] = useState(false);
  const [iscatshow, setiscatshow] = useState(true);
  const [isownershow, setisownershow] = useState(false);
  const [isvalshow, setisvalshow] = useState(true);
  const [isspec1, setisspec1] = useState(true);
  const [isspec2, setisspec2] = useState(true);
  const [isspec3, setisspec3] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [baseimage, setbaseimage] = useState("");
  const [renderCount, setRenderCount] = useState(0);
  const [base64Images, setBase64Images] = useState([]);
  const [roundbase64Images, setroundBase64Images] = useState([]);
  const [aucteambase64, setaucteambase64] = useState([]);
  const [aucdata, setaucdata] = useState([]);
  const [auclogo, setauclogo] = useState();
  const [aucdate, setaucdate] = useState();
  const [auclogopath, setauclogopath] = useState();
  const [aucminbid, setaucminbid] = useState();
  const [teampath, setteampath] = useState("");
  const [isexcelmore, setisexcelmore] = useState("");
  const [isexcelsp1, setisexcelsp1] = useState(true);
  const [isexcelsp2, setisexcelsp2] = useState(true);
  const [isexcelsp3, setisexcelsp3] = useState(false);
  const [isexceltshirt, setisexceltshirt] = useState(true);
  const [isexceltrouser, setisexceltrouser] = useState(true);
  const [isexcelcat, setisexcelcat] = useState(true);
  const [isexcelplno, setisexcelplno] = useState(true);
  const [isexcelage, setisexcelage] = useState(true);
  const [isexcelmob, setisexcelmob] = useState(true);
  const [isexceldob, setisexceldob] = useState(true);
  const [isexcelpoints, setisexcelpoints] = useState(true);
  const [isexcelteam, setisexcelteam] = useState(true);
  const [isexcelfname, setisexcelfname] = useState(true);
  const [isexceljname, setisexceljname] = useState(true);
  const [isexceljno, setisexceljno] = useState(true);
  const [isexceldetail, setisisexceldetail] = useState(true);
  const [isexcelimage, setisexcelimage] = useState(true);
  const [isexcelbasebid, setisexcelbasebid] = useState(false);
  const [topnum, settopnum] = useState(5);
  const [toptype, settoptype] = useState("0");
  const [sponsorlogo, setsponsorlogo] = useState("");
  const [cusbg, setcusbg] = useState("");
  const [ignoretype, setignoretype] = useState("");
  const [ignorecat, setignorecat] = useState("");
  const [ignoretag, setignoretag] = useState("");
  const [ignoreplnos, setignoreplnos] = useState("");
  const [pdflayouttype, setpdflayouttype] = useState("");
  const [toppltype, settoppltype] = useState("");
  const [isvicecaptaintagselect, setisvicecaptaintagselect] = useState(true);

  const [isownertagselect, setisownertagselect] = useState(true);
  const [iscoownertagselect, setiscoownertagselect] = useState(true);
  const [iscaptaintagselect, setiscaptaintagselect] = useState(true);
  const [isicontagselect, setisicontagselect] = useState(true);
  const [isretaintagselect, setisretaintagselect] = useState(true);
  const [fontcolor, setfontcolor] = useState(localStorage.getItem("pdffont"));
  const [ispdfwhitebg, setispdfwhitebg] = useState(
    localStorage.getItem("ispdfwhitebg")
  );
  const [generatecatid, setgeneratecatid] = useState("");
  const [isnocatshow, setisnocatshow] = useState(false);

  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const [receiptList, setReceiptList] = useState([]);
  const [receiptpath, setreceiptpath] = useState("");

  const [playerImagesBase64, setPlayerImagesBase64] = useState({});
  const [hoveredImg, setHoveredImg] = useState(null);
  const [dynamicRunwktFields, setDynamicRunwktFields] = useState({});
  const handleDeleteImage = async (pid, aid) => {
    const token = loginuser["token"];
    if (!pid || !aid) {
      toast.error("Missing pid or aid");
      return;
    }

    if (!window.confirm("Delete image?")) return;
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    try {
      const res = await DataService.delimg(
        {
          pid: pid,
          aid: aid

        }, hdr
      );

      if (res.data.success) {
        toast.success(res.data.msg);

        setData(prev => ({
          ...prev,
          list: prev.list.map(x =>
            x.pid === pid ? { ...x, img: "" } : x
          )
        }));

      } else {
        toast.error(res.data.msg);
      }

    } catch (err) {
      toast.error("Server error");
    }
  };






  const [duplicateMobiles, setDuplicateMobiles] = useState([]); // duplicate mobile numbers store karega
  const [showMobileDuplicateModal, setShowMobileDuplicateModal] =
    useState(false); // modal show/hide

  // const [isexcelsp1, setisexcelsp1] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [excelfields, setexcelfields] = useState({""});

  const updtoken = useSelector((state) => state.updtoken);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);
  const [extra, setextra] = useState(aucmoredetail?.extra);

  // const history = useHistory({ forceRefresh: true });

  const [filter, setFilter] = useState(
    getfilters != 0
      ? getfilters
      : {
        searchText: "",
        selectedStatus: "",
        selectedCategory: "1",
      }
  );
  const imageRefs = useRef([]);
  const aucteamrefs = useRef([]);
  const pldefault = useRef([]);
  // const canvasRefs = useRef([]);

  // const imageRef = useRef(null);
  const pdfContainerRefs = useRef([]);
  // const yourImageRef = useRef(null);
  const history = useHistory();

  // State for tracking duplicate player codes
  const [duplicatePcodes, setDuplicatePcodes] = useState([]);
  const [duplicateNameAndMobile, setDuplicateNameAndMobile] = useState([]); // ← naya state

  // Function to check for duplicate player codes
  const checkDuplicatePcodes = (playerList) => {
    if (!playerList || playerList.length === 0) return [];

    // Create a map to track occurrences of each pcode
    const pcodeMap = {};
    const duplicates = [];

    // Count occurrences of each pcode
    playerList.forEach((player) => {
      if (!player.pcode) return;

      if (pcodeMap[player.pcode]) {
        pcodeMap[player.pcode]++;

        // If this is the first time we've found this duplicate, add it to our list
        if (pcodeMap[player.pcode] === 2) {
          duplicates.push(player.pcode);
        }
      } else {
        pcodeMap[player.pcode] = 1;
      }
    });

    return duplicates;
  };

  const checkDuplicateMobiles = (playerList) => {
    if (!playerList || playerList.length === 0) return [];

    const mobileMap = {};
    const duplicates = [];

    playerList.forEach((player) => {
      const mobile = player.mob?.toString().trim();
      if (!mobile) return;

      if (mobileMap[mobile]) {
        mobileMap[mobile]++;
        if (mobileMap[mobile] === 2) {
          duplicates.push(mobile);
        }
      } else {
        mobileMap[mobile] = 1;
      }
    });

    return duplicates;
  };

  const checkDuplicateNameAndMobile = (playerList) => {
    if (!playerList || playerList.length === 0) return [];

    const seen = {};
    const duplicates = [];

    playerList.forEach((player) => {
      const pname = player.pname?.trim();
      const mobile = player.mob?.toString().trim();

      if (!pname || !mobile) return;

      const key = `${pname.toLowerCase()}|${mobile}`;

      if (seen[key]) {
        seen[key].count++;
        if (seen[key].count === 2) {
          duplicates.push({
            pname: pname,
            mobile: mobile,
          });
        }
      } else {
        seen[key] = { count: 1 };
      }
    });

    return duplicates;
  };

  const fetchcatData = async () => {
    //console.log('fetchcatData CALLING..........')
    // setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          // //  //// //console.log(responsedata)
          let responsedata = response.data;
          //  // //console.log(" cat list kya h");
          // //  //// //console.log(responsedata.list.sort((a, b) => a.catord - b.catord));
          //console.log('responsedata.list.............................')
          //console.log(responsedata.list)

          setcatData(responsedata.list.sort((a, b) => a.catord - b.catord));
        }
        // setActive(false);
      })
      .catch(() => {
        //  //// //console.log('Not valid')
        // setActive(false);
      });
  };
  // const handleGeneratePdf = () => {
  //   const doc = new jsPDF({
  //     format: 'a4',
  //     unit: 'px',
  //   });

  //   // Adding the fonts.
  //   doc.setFont('Inter-Regular', 'normal');

  //   doc.html(reportTemplateRef.current, {
  //     async callback(doc) {
  //       await doc.save('document');
  //     },
  //   });
  // };
  const handleGeneratePdf = () => {
    const input = reportTemplateRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      // const imgWidth = canvas.width;
      // const imgHeight = canvas.height;
      // const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      // const imgX = (pdfWidth - imgWidth * ratio) / 2;
      // const imgY = 30;
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        pdf.internal.pageSize.getWidth(),
        pdf.internal.pageSize.getHeight()
      );
      pdf.save("player_report.pdf");
    });
  };
  const fetchaucData = async () => {
    setActive(true);
    // //  //// //console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;

          setaucdata(responsedata);
          // //console.log('check..........')
          // //console.log(responsedata.list.filter((ele) => ele.aid == aid)[0])

          setcurrentauc(responsedata.list.filter((ele) => ele.aid == aid)[0]);
          setauclogo(responsedata.list.filter((ele) => ele.aid == aid)[0].logo);
          setaucdate(responsedata.list.filter((ele) => ele.aid == aid)[0].dt);
          setaucminbid(
            responsedata.list.filter((ele) => ele.aid == aid)[0].minbid
          );
          setauclogopath(responsedata.path);
        }

        setActive(false);
      })
      .catch(() => {
        //  //// //console.log("Not valid");
        setActive(false);
      });
  };

  const fetchTeamData = async () => {
    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          let responsedata = response.data;
          // //console.log('responsedata.list')
          // //console.log(responsedata.list)

          setTeamData(responsedata.list);
          setteampath(responsedata.path);
          dispatch(teamlistData({ responsedata }));
        }
      })
      .catch(() => {
        //  //// //console.log("Not valid");
      });
  };

  // const fetchData = async () => {

  //   //  //// //console.log("api called again....")
  //   // //  //// //console.log(aid)
  //   setActive(true);

  //   var hdr = {
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded", //v
  //       authorization: JSON.stringify([
  //         { cid: cid, aid: aid, token: loginuser["token"] },
  //       ]),
  //     },
  //   };

  //   await DataService.listPlayer({ self: 1 }, hdr)
  //     .then((res) => {
  //       let response = res.data;
  //       //console.log('players data')
  //       //console.log(response)

  //       if (response.success == true) {
  //         let responsedata = response.data;
  //         setData(responsedata);
  //         // //console.log('data coming.....')
  //         // //console.log(responsedata)
  //         const sortedData = responsedata.list.sort((a, b) => a.pcode - b.pcode);
  //         // //console.log('sortedData')
  //         // //console.log(sortedData)
  //         responsedata.list = sortedData;
  //         setplData(responsedata);
  //         setReceiptList(responsedata.receipts);
  //         setreceiptpath(responsedata.rpath);
  //         dispatch(playerlistData({ responsedata }));

  //         // Check for duplicate player codes after data is loaded
  //         const duplicates = checkDuplicatePcodes(responsedata.list);
  //         setDuplicatePcodes(duplicates);

  //         // Removed toast notification
  //       }

  //       setActive(false);
  //     })
  //     .catch(() => {
  //       //  //// //console.log("Not valid");
  //       setActive(false);
  //     });

  // };
  const fetchData = async () => {
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    try {
      const res = await DataService.listPlayer({ self: 1 }, hdr);
      let response = res.data;

      if (response.success == true) {
        let responsedata = response.data;
        setData(responsedata);

        const sortedData = responsedata.list.sort((a, b) => a.pcode - b.pcode);
        responsedata.list = sortedData;

        setplData(responsedata);
        setReceiptList(responsedata.receipts);
        setreceiptpath(responsedata.rpath);
        dispatch(playerlistData({ responsedata }));

        // Check duplicate pcodes (already there)
        const duplicatePcodesFound = checkDuplicatePcodes(responsedata.list);
        setDuplicatePcodes(duplicatePcodesFound);

        // Check duplicate mobiles (new)
        const duplicateMobilesFound = checkDuplicateMobiles(responsedata.list);
        setDuplicateMobiles(duplicateMobilesFound); // sirf state update, no modal

        // Inside fetchData, after setting other duplicates
        const nameMobileDuplicates = checkDuplicateNameAndMobile(
          responsedata.list
        );
        setDuplicateNameAndMobile(nameMobileDuplicates);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setActive(false);
    }
  };
  useEffect(() => {
    console.log("pldata");
    console.log(data.list);
  }, [data]);

  const loadPlayerImages = async () => {
    setIsbase64Loading(true);
    // //console.log('loadPlayerImages CALLING..........')
    if (!pldata) return;
    // //console.log('pldata')
    // //console.log(pldata)

    const imagesObj = {};
    const roundedImagesObj = {};
    const playerList = pldata.list;
    const imagePath = pldata.path || "";
    // //console.log('playerList...................')
    // //console.log(playerList)
    // //console.log(imagePath)

    try {
      setActive(true);
      // //console.log("Loading player images. Path:", imagePath);

      // Process in batches to avoid overwhelming the browser
      const batchSize = 5;
      const totalPlayers = playerList.length;
      const loadingMsg = document.getElementById("custom-loading-message");

      for (let i = 0; i < totalPlayers; i += batchSize) {
        const batch = playerList.slice(i, i + batchSize);

        // Update progress message if the element exists
        if (loadingMsg) {
          const progress = Math.min(100, Math.round((i / totalPlayers) * 100));
          loadingMsg.innerHTML = `<div>Please wait, Processing data...</div><div>Loading player images: ${progress}%</div>`;
        }

        // Process batch sequentially to avoid too many simultaneous requests
        for (const player of batch) {
          if (player.img && player.img !== "") {
            try {
              const imageUrl = imagePath + player.img;
              // //console.log(`Converting image for player ${player.pid}: ${imageUrl}`);

              const base64 = await convertImageToBase64(imageUrl);
              // //console.log('base64..............................')
              // //console.log(base64)
              if (base64) {
                // //console.log('base64')
                // //console.log(base64)
                // //console.log(`Successfully converted image for player ${player.pid}`);
                imagesObj[player.pid] = base64.regular;
                roundedImagesObj[player.pid] = base64.rounded;
              } else {
                console.warn(
                  `Failed to convert image for player ${player.pid}`
                );
                // Use a default image instead
                imagesObj[player.pid] = playerdefaultLogo;
                // roundedImagesObj[player.pid] = playerdefaultLogo;
              }
            } catch (err) {
              console.error(
                `Error processing image for player ${player.pid}:`,
                err
              );
              imagesObj[player.pid] = playerdefaultLogo;
              // roundedImagesObj[player.pid] = playerdefaultLogo;
            }
          } else {
            // //console.log(`No image for player ${player.pid}, using default`);
            imagesObj[player.pid] = playerdefaultLogo;
            // roundedImagesObj[player.pid] = playerdefaultLogo;
          }
        }
      }

      // Update to 100% when done
      if (loadingMsg) {
        loadingMsg.innerHTML = `<div>Please wait, Processing data...</div><div>Loading player images: 100%</div>`;
      }

      // //console.log(`Converted ${Object.keys(imagesObj).length} player images to base64`);
      setPlayerImagesBase64(imagesObj);
      setroundBase64Images(roundedImagesObj);
    } catch (error) {
      console.error("Error loading player images:", error);
    } finally {
      setIsbase64Loading(false);
    }
  };

  // const fetchReceiptList = async () => {
  //   setActive(true);

  //   var hdr = {
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded", //v
  //       authorization: JSON.stringify([
  //         { cid: cid, aid: aid, token: loginuser["token"] },
  //       ]),
  //     },
  //   };

  //   try {
  //     const response = await DataService.listReceipts({ 'aid': aid }, hdr);
  //     // //console.log('receipt response');
  //     // //console.log(response)
  //     if (response.data.success) {
  //       setReceiptList(response.data.data.list || []);
  //     } else {
  //       toast.error(response.data.msg, {
  //         theme: "colored",
  //         position: "bottom-center",
  //       });
  //     }
  //   } catch (error) {
  //     toast.error("Failed to fetch receipts", {
  //       theme: "colored",
  //       position: "bottom-center",
  //     });
  //   } finally {
  //     setActive(false);
  //   }
  // };

  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deletePlayer({ pid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            console.log("response");
            console.log(response);
            if (response.success == true) {
              const db = getDatabase();

              set(ref(db, "map/info/" + aid), {
                type: "4",
                upd: "3",
                id: vl,
                detail: "",
                tkn: updtoken,
              });
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updatedList = (data?.list || []).filter(
                (ele) => ele.pid != vl
              );
              // Update local component state immutably
              setData({ path: data?.path, aid: data?.aid, list: updatedList });
              setplData({
                path: data?.path,
                aid: data?.aid,
                list: updatedList,
              });
              // Sync Redux cache immutably
              dispatch(
                playerlistData({
                  responsedata: {
                    path: data?.path,
                    aid: data?.aid,
                    list: updatedList,
                  },
                })
              );
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }
            setActive(false);
          })
          .catch(() => {
            //  //// //console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [aid, cid, dispatch, loginuser, updtoken, data]
  );

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };

  function gotoimport() {
    history.push(BASE_PATH + "import-players");
  }
  // const gettBase64Image = async (url) => {
  //   const response = await fetch(url);
  //   const blob = await response.blob();
  //   return new Promise((resolve) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result);
  //     reader.readAsDataURL(blob);
  //   });
  // };
  const pdfdownload2 = (playerlist) => {
    //  // //console.log('psf player list')
    //  // //console.log(playerlist)
    if (getcatpageData == 0) {
      fetchcatData();
    }
    const doc = new jsPDF("p", "mm", "a4");

    doc.addImage(pdfbg, "JPEG", 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)
    doc.addImage(pdfauctiontitlebg, "JPEG", 50, 10, 110, 20);
    if (aucteambase64[0]) {
      if (orderby2 !== "3") {
        doc.addImage(aucteambase64[0], "JPEG", 10, 10, 20, 20);
      }

      if (isspnshow && aucteambase64[1]) {
        doc.addImage(aucteambase64[1], "JPEG", 175, 10, 20, 20);
      } else {
        doc.addImage(aucteambase64[0], "JPEG", 175, 10, 20, 20);
      }
    } else {
      doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 20, 20);
      doc.addImage(auctiondefaultLogo, "JPEG", 175, 10, 20, 20);
    }
    //////////////team wise (Team logo)///////////
    if (orderby2 == 3) {
      if (aucteambase64[playerlist[0].tmid]) {
        doc.addImage(aucteambase64[playerlist[0].tmid], "JPEG", 10, 10, 20, 20);
      }
    }

    /////////////////Auction name/////////////////////
    doc.setTextColor(255, 255, 255);

    if (acname.length < 27) {
      let alen = acname.length * 3.5;
      doc.text(acname.toUpperCase(), 105 - alen / 2, 22);
    } else {
      doc.setFontSize(15);

      var fstr = linechanger(acname, 27);
      let alen1 = fstr[0].length * 3.2;

      doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
      if (fstr[1].length <= 25) {
        doc.setFontSize(14);

        let alen2 = fstr[1].length * 2.9;

        doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 25);
      } else {
        var fsstr = linechanger(fstr[1], 25);
        doc.setFontSize(14);

        let alen2 = fsstr[0].length * 2.9;
        let alen3 = fsstr[1].length * 2.9;
        doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
        doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);
      }
    }

    //////////////////////////////////////////////////

    let centerX = 30;
    let centerY = 60;
    let imageSize = 20; // Size of the Image
    let radius = imageSize / 2 + 3; // Radius of the arc
    let adjustCenter = imageSize / 2;

    // Player Printing Maching
    var dumcatid = playerlist[0].catid;
    var dumtid = playerlist[0].tmid;
    let count = 0;
    let counter = 0;
    playerlist.map((player, index) => {
      if (player.isnonplay == 1) {
        return null;
      }

      if (count == 0) {
        if (orderby2 == 2 && catdata) {
          var catname = catdata?.filter((ct) => ct.cid == player.catid)[0]
            .cname;
          const categoryText = catname.toUpperCase();
          const categoryTextWidth = doc.getTextWidth(categoryText);
          //  // //console.log('category name')
          doc.text(
            categoryText,
            (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
            50
          );
          centerY = 70;
        }
        if (orderby2 == 3) {
          var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
          const teamText = teamname.toUpperCase();
          const teamTextWidth = doc.getTextWidth(teamText);
          doc.text(
            teamText,
            (doc.internal.pageSize.getWidth() - teamTextWidth) / 2,
            35
          );
        }
      }
      if (orderby2 == 2) {
        if (dumcatid !== player.catid) {
          dumcatid = player.catid;
          counter = 0;
          count = 0;
          doc.addPage();
          doc.setFontSize(16);
          //  // //console.log('at catdata')
          if (catdata) {
            //  // //console.log('inside catdata')
            var catname = catdata?.filter((ct) => ct.cid == player.catid)[0]
              .cname;
            //  // //console.log(catname)
          }
          doc.addImage(
            pdfbg,
            "JPEG",
            1,
            1,
            doc.internal.pageSize.width - 2,
            doc.internal.pageSize.height - 2
          );
          doc.addImage(pdfauctiontitlebg, "JPEG", 50, 10, 110, 20);

          // doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          if (aucteambase64[0]) {
            doc.addImage(aucteambase64[0], "JPEG", 10, 10, 20, 20);
            if (isspnshow && aucteambase64[1]) {
              doc.addImage(aucteambase64[1], "JPEG", 175, 10, 20, 20);
            } else {
              doc.addImage(aucteambase64[0], "JPEG", 175, 10, 20, 20);
            }
          } else {
            doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 20, 20);
            doc.addImage(auctiondefaultLogo, "JPEG", 175, 10, 20, 20);
          }

          if (acname.length < 27) {
            let alen = acname.length * 4;

            doc.text(acname.toUpperCase(), 105 - alen / 2, 20);
          } else {
            doc.setFontSize(15);

            var fstr = linechanger(acname, 27);
            let alen1 = fstr[0].length * 3.2;

            doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
            if (fstr[1].length <= 25) {
              doc.setFontSize(14);

              let alen2 = fstr[1].length * 2.9;

              doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 26);
            } else {
              var fsstr = linechanger(fstr[1], 25);
              doc.setFontSize(14);

              let alen2 = fsstr[0].length * 2.9;
              let alen3 = fsstr[1].length * 2.9;
              doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 26);
              doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 32);
            }
          }
          doc.setFontSize(16);
          const categoryText = catname.toUpperCase();
          const categoryTextWidth = doc.getTextWidth(categoryText);
          doc.text(
            categoryText,
            (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
            35
          );
          centerX = 30;
          centerY = 70;
          // x = 10;
          // y = 60
        }
      }
      if (orderby2 == 3) {
        // //  // //console.log("team ki pdfff")

        if (dumtid !== player.tmid) {
          // //  // //console.log("team change hui")
          dumtid = player.tmid;
          counter = 0;
          count = 0;
          doc.addPage();
          doc.setFontSize(16);
          var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
          // doc.addImage(aucteambase64[player.tmid], 'JPEG', 75, 35, 15, 15);
          doc.addImage(
            pdfbg,
            "JPEG",
            1,
            1,
            doc.internal.pageSize.width - 2,
            doc.internal.pageSize.height - 2
          );
          // doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
          doc.addImage(pdfauctiontitlebg, "JPEG", 50, 10, 110, 20);

          if (aucteambase64[0]) {
            if (isspnshow && aucteambase64[1]) {
              doc.addImage(aucteambase64[1], "JPEG", 175, 10, 20, 20);
            } else {
              doc.addImage(aucteambase64[0], "JPEG", 175, 10, 20, 20);
            }
          } else {
            doc.addImage(auctiondefaultLogo, "JPEG", 175, 10, 20, 20);
          }
          if (aucteambase64[player.tmid]) {
            doc.addImage(aucteambase64[player.tmid], "JPEG", 10, 10, 20, 20);
          } else {
            doc.addImage(teamdefaultLogo, "JPEG", 10, 10, 20, 20);
          }

          doc.setFontSize(18);

          if (acname.length < 27) {
            let alen = acname.length * 4;

            doc.text(acname.toUpperCase(), 105 - alen / 2, 20);
          } else {
            doc.setFontSize(15);

            var fstr = linechanger(acname, 27);
            let alen1 = fstr[0].length * 3.2;

            doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
            if (fstr[1].length <= 25) {
              doc.setFontSize(14);

              let alen2 = fstr[1].length * 2.9;

              doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 26);
            } else {
              var fsstr = linechanger(fstr[1], 25);
              doc.setFontSize(14);

              let alen2 = fsstr[0].length * 2.9;
              let alen3 = fsstr[1].length * 2.9;
              doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 26);
              doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 32);
            }
          }
          doc.setFontSize(10);

          // doc.text('TEAM PLAYER LIST', 88, 45);
          doc.setFontSize(16);
          const teamText = teamname;
          const teamTextWidth = doc.getTextWidth(teamText);

          doc.text(
            teamText,
            (doc.internal.pageSize.getWidth() - teamTextWidth) / 2,
            35
          );
          centerX = 30;
          centerY = 70;
          // doc.addImage(auctiondefaultLogo, 'JPEG', 75, 45, 20, 20);
        }
      }
      // Border circles
      doc.setDrawColor(165, 148, 247);
      doc.setLineWidth(1);
      doc.circle(centerX, centerY, imageSize / 2 + 0.2, "S");
      doc.setDrawColor(170, 180, 227);
      doc.setLineWidth(0.3);
      doc.circle(centerX, centerY, imageSize / 2 + 1.8, "S");
      // Player Image
      const plingindex = data.list.findIndex((elem) => elem.pid === player.pid);

      doc.addImage(
        roundbase64Images[player.pid],
        "jpeg",
        centerX - adjustCenter,
        centerY - adjustCenter,
        imageSize,
        imageSize
      );

      const text = player.pname; // Text to display
      let rta = 0;
      let tlength = text.length / 2;
      const angleOffset = -(Math.PI / 2) * ((tlength + 1) / 14); // Start from top of the circle (-90 degrees)
      let falselength = 26; ///text.length

      doc.setFontSize(8);
      doc.setTextColor("#ffffff"); // White color or adjust based on background
      doc.setFont("Courier", "normal");

      for (let i = 0; i < text.length; i++) {
        rta = (tlength - 0.5 - i) * 7;
        const char = text[i];
        const angle =
          angleOffset + (i - (falselength - 1) / 2) * (Math.PI / falselength); // Distribute letters along the arc
        const rotationAngle = angle + Math.PI / 2;
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);
        doc.text(char, x, y, null, rta); // Draw each character
      }
      // doc.setTextColor('#d97c11')
      doc.setFont("Courier", "bold");
      doc.setFontSize(6);
      doc.text(String(index + 1), centerX - (radius + 3), centerY); // Draw each character
      doc.setTextColor("#ffffff");

      ///////////////page change logic/////////////

      centerX += 36;

      if ((counter + 1) % 5 == 0) {
        centerY += 30;
        centerX = 30;
      }
      if ((counter + 1) % 40 == 0) {
        doc.addPage();
        doc.addImage(pdfbg, "JPEG", 0, 0, 210, 297); // Position (x=0, y=0), Size (210mm x 297mm for A4)

        centerY = 50;
        centerX = 30;
      }
      count += 1;
      counter += 1;
    });

    setpdfclk(false);
    if (orderby2 == "" || orderby2 == 1) {
      doc.save(aid + "-" + acname.toUpperCase() + "_PLIST.pdf");
    }
    if (orderby2 == 2) {
      doc.save(aid + "-" + acname.toUpperCase() + "_PLIST_CATEGORY.pdf");
    }
    if (orderby2 == 3) {
      doc.save(aid + "-" + acname.toUpperCase() + "_PLIST_TEAM.pdf");
    }
  };
  function pdfdownload() {
    if (data != "") {
      // orderby1-------------------------------------------
      if (orderby == 2) {
        var pdfdata = [...data.list].sort((a, b) =>
          a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1
        );
      } else if (orderby == 1) {
        var pdfdata = [...data.list].sort((a, b) =>
          Number(a.pcode) < Number(b.pcode) ? -1 : 1
        );
      } else if (orderby == 5 || orderby2 == 3) {
        var teamwisefull = [];

        dataTeam.forEach((tm) => {
          var teamwise = [];
          teamwise = data.list.filter((dt) => dt.tmid == tm.tid);

          if (orderby == 5) {
            if (teamwise.length > 0) {
              teamwise.sort((a, b) => a.soldseq - b.soldseq);
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele);
            });
          } else if (orderby == 7) {
            if (teamwise.length > 0) {
              teamwise.sort((a, b) => b.points - a.points);
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele);
            });
          } else if (orderby == 8) {
            if (teamwise.length > 0) {
              teamwise.sort((a, b) =>
                a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1
              );
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele);
            });
          } else if (orderby == 6 && catdata !== "") {
            if (teamwise.length > 0) {
              // var catteammain=[]
              catdata.forEach((ct) => {
                var catteam = [];
                teamwise.forEach((tw) => {
                  if (ct.cid == tw.catid) {
                    catteam.push(tw);
                  }
                });
                if (catteam.length > 0) {
                  catteam.forEach((ele) => {
                    teamwisefull.push(ele);
                  });
                }
              });
              teamwise.forEach((tw) => {
                if (tw.catid == "0") {
                  teamwisefull.push(tw);
                }
              });
            }
          } else {
            teamwise.forEach((ele) => {
              teamwisefull.push(ele);
            });
          }
        });

        var pdfdata = teamwisefull;
      } else {
        var pdfdata = data.list;
      }
      // orderby2-------------------------------------------
      if (orderby2 == 2 || orderby == 3 || orderby == 4) {
        if (catdata !== "" && catdata !== null) {
          var catwisefull = [];
          if (generatecatid !== "") {
            var generatecat = catdata.filter((ct) => ct.cid == generatecatid);
            // //console.log('generatecat', generatecat);
          } else {
            generatecat = catdata;
          }
          if (generatecatid == "0") {
            catwisefull = pldata.list.filter((pl) => pl.catid == "0");
          } else {
            generatecat.forEach((ct) => {
              var catwise = [];

              catwise = pldata.list.filter((dt) => dt.catid == ct.cid);
              if (catwise.length > 0) {
                if (orderby == 2 || orderby == 4) {
                  catwise.sort((a, b) =>
                    a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1
                  );
                } else if (orderby == 1) {
                  // Sort by player code (pcode) for player number order'
                  // //console.log('catwise', catwise);
                  catwise.sort((a, b) => parseInt(a.pcode) - parseInt(b.pcode));
                } else {
                  // Sort by player code (pcode) for player number order'
                  // //console.log('catwise', catwise);
                  catwise.sort((a, b) => parseInt(a.pcode) - parseInt(b.pcode));
                }

                catwise.forEach((ele) => {
                  catwisefull.push(ele);
                });
              }
            });
          }

          var pdfdata = catwisefull;
          if (isnocatshow) {
            pdfdata.push(...pldata.list.filter((pl) => pl.catid == "0"));
          }
          // //// //console.log('pdfdata')
          // //// //console.log(pdfdata)
        }
      }
      // else if(orderby2==1 || orderby2==""){
      //   var pdfdata = data.list
      // }
      //

      // column number----------------------------------------------------------
      if (colno == 1) {
        var column = 2;
      } else if (colno == 2) {
        var column = 3;
      } else {
        var column = 3;
      }
      // perpage--------------------------------------------------
      if (numofpl == "" && colno == 2) {
        var perpage = 27;
      } else if (numofpl == "" && colno == 1) {
        var perpage = 14;
      } else if (numofpl !== "") {
        var perpage = numofpl;
      } else {
        var perpage = 27;
      }

      // status-------------------------------------------------------------------
      if (sts == "" || sts == 1) {
        var pdfdata = pdfdata;
      } else {
        if (sts == 2) {
          var pdfdata = pdfdata.filter(
            (pl) =>
              (pl.tmid == 0 || pl.tmid == "") &&
              pl.isskiped != "1" &&
              pl.isnonplay != "1"
          );
        } else if (sts == 3) {
          // //  //// //console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid > 0);
        } else if (sts == 4) {
          // //  //// //console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.isskiped == "1");
        } else if (sts == 5) {
          // //  //// //console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid == 0 || pl.tmid == "");
        } else if (sts == 6) {
          // //  //// //console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid == 0 || pl.tmid == "");
        }
      }

      if (pdfdata == [] || pdfdata == null || pdfdata.length == 0) {
        alert("No Player Data !!");
        return 0;
      }

      // var pdfdata = [...data.list].sort((a, b) =>
      //   a.fname < b.fname.toLowerCase() ? -1 : 1,
      // );
      // //console.log('pdfdata', pdfdata);

      const doc = new jsPDF();

      // doc.text('Player List', 15, 10);

      // let yOffset = 20;
      ///-----2/3 column
      ///--first page / Per page record
      //////////////////////////////2X6///////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 12) {
        var perpage = 12;

        var rightbox = 98;
        var bottombox = 40;

        var rectwide = 94;
        var reactheight = 32;

        var imgwidth = 30;
        var imgheight = 30;

        var nameagefont = 12;
        var namex = 33;
        var namey = 5;
        var agex = 53;
        var agey = 11;

        var plnox = 33;
        var plnoy = 11;

        var spcffont = 10;
        var spcfx = 33;
        var spcfy = 20;
        var extra = 2;
      }
      ///////////////////////////////////////////2 x 7//////////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 14) {
        var perpage = 14;

        var rightbox = 98;
        var bottombox = 33;

        var rectwide = 94;
        var reactheight = 29;

        var imgwidth = 27;
        var imgheight = 27;

        var nameagefont = 12;
        var namex = 30;
        var namey = 5;
        var agex = 50;
        var agey = 11;

        var plnox = 30;
        var plnoy = 11;

        var spcffont = 10;
        var spcfx = 30;
        var spcfy = 20;
        var extra = 2;
      }
      ///////////////////////////////////////////////2 x 8/////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 16) {
        var perpage = 16;

        var rightbox = 98;
        var bottombox = 29;

        var rectwide = 94;
        var reactheight = 26;

        var imgwidth = 24;
        var imgheight = 24;

        var nameagefont = 10;
        var namex = 28;
        var namey = 5;
        var agex = 48;
        var agey = 11;

        var plnox = 28;
        var plnoy = 11;

        var spcffont = 9;
        var spcfx = 28;
        var spcfy = 20;

        var extra = 2;
      }
      /////////////////////////////////////// 3 x 8 //////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 24) {
        var perpage = 24;

        var rightbox = 65;
        var bottombox = 29;

        var rectwide = 62;
        var reactheight = 24;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9;

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;
        var extra = 6;
      }
      /////////////////////////////////////////////// 3 x 9 ///////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 27) {
        var perpage = 27;

        var rightbox = 65;
        var bottombox = 26;

        var rectwide = 62;
        var reactheight = 24;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9;

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;
      }
      //////////////////////////////////////////// 3 x 10 ///////////////////////////////////////////////////
      if (column == 3 && perpage == 30) {
        var perpage = 30;

        var rightbox = 65;
        var bottombox = 23;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9;

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;
      }
      /////////////////////////////////////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 33) {
        var perpage = 33;

        var rightbox = 65;
        var bottombox = 21;

        var rectwide = 62;
        var reactheight = 20;

        var imgwidth = 18;
        var imgheight = 18;

        var nameagefont = 7;
        var namex = 21;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 21;
        var plnoy = 9;

        var spcffont = 6;
        var spcfx = 21;
        var spcfy = 14;
        var extra = 6;
      }

      function linechanger(str, count) {
        var plsp = str.split(" ");
        let plsplen = 0;
        let whichsp = 0;
        let firststr = "";
        let secstr = "";
        for (let i = 0; i < plsp.length; i++) {
          plsplen += plsp[i].length;

          if (plsplen > count) {
            break;
          }
          whichsp += 1;
        }
        var linearr = [];
        for (let y = 0; y < whichsp; y++) {
          if (firststr !== "") {
            firststr += " ";
          }
          firststr += plsp[y];
        }
        linearr.push(firststr);

        for (let z = whichsp; z < plsp.length; z++) {
          if (secstr !== "") {
            secstr += " ";
          }
          secstr += plsp[z];
        }
        linearr.push(secstr);
        return linearr;
      }
      var counter = 0;
      var count2 = 0;
      var plno = 1;
      let x = 10;
      let y = 60;

      if (aucteambase64[2]) {
        doc.addImage(
          aucteambase64[2],
          "JPEG",
          1,
          1,
          doc.internal.pageSize.width - 2,
          doc.internal.pageSize.height - 2
        );
      } else {
        if (ispdfwhitebg == "1") {
          doc.addImage(
            whitebg,
            "JPEG",
            1,
            1,
            doc.internal.pageSize.width - 2,
            doc.internal.pageSize.height - 2
          );
        } else {
          doc.addImage(
            pdfbg,
            "JPEG",
            1,
            1,
            doc.internal.pageSize.width - 2,
            doc.internal.pageSize.height - 2
          );
        }
      }
      doc.setDrawColor(72, 104, 153);
      doc.rect(9.5, 9.5, 41, 41);

      doc.setDrawColor(72, 104, 153);
      doc.rect(159.5, 9.5, 41, 41);

      // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // if(aucteambase64[1]){
      //   doc.addImage(aucteambase64[1], 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // }
      // else{
      //   doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // }

      // if(aucteambase64[2]){
      //   // //console.log('back ground image')
      //   //// //console.log('back ground image')
      //   // doc.addImage(aucteambase64[2], 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // }
      // else{
      //   // doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // }
      // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // //  //// //console.log("jjjjjjjjjjjjjjjjjjjjjj")

      // //  //// //console.log(aucteambase64)
      // doc.setFillColor(255, 255, 255);
      // doc.rect(10, 10, 40, 40,'F');
      // doc.rect(160, 10, 40, 40);

      // //  //// //console.log(aucteambase64[0])
      // //  //// //console.log(aucteambase64[1])
      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], "JPEG", 10, 10, 40, 40);
        if (isspnshow && aucteambase64[1]) {
          doc.addImage(aucteambase64[1], "JPEG", 160, 10, 40, 40);
          // gettBase64Image('https://mscsuper.blr1.digitaloceanspaces.com/sponsor/29390250127161937653.jpg').then((base64) => {
          //   doc.addImage(base64, 'JPEG', 160, 10, 40, 40);
          // });
        } else {
          doc.addImage(aucteambase64[0], "JPEG", 160, 10, 40, 40);
        }
        // //  //// //console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")
      } else {
        doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, "JPEG", 160, 10, 40, 40);
      }
      if (orderby2 == 3) {
        if (aucteambase64[pdfdata[0].tmid]) {
          doc.addImage(aucteambase64[pdfdata[0].tmid], "JPEG", 10, 10, 40, 40);
        }
      }
      // doc.setDrawColor(72, 104, 153);

      //   doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(159.5, 9.5, 41, 41);
      doc.setFont("NotoSansGujarati-Regular", "normal");

      if (fontcolor == 0) {
        doc.setTextColor(255, 255, 255);
      } else {
        doc.setTextColor(20, 14, 92);
      }
      doc.setFontSize(18);
      if (acname.length < 27) {
        let alen = acname.length * 4;
        // doc.setTextColor(196, 147, 14);

        doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
        // doc.setTextColor(255, 255, 255);
      } else {
        doc.setFontSize(15);

        var fstr = linechanger(acname, 27);
        //27 old
        let alen1 = fstr[0].length * 3.2;

        doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18); //105 old
        if (fstr[1].length <= 25) {
          doc.setFontSize(14);

          let alen2 = fstr[1].length * 2.9;

          doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
        } else {
          var fsstr = linechanger(fstr[1], 25);
          doc.setFontSize(14);

          let alen2 = fsstr[0].length * 2.9;
          let alen3 = fsstr[1].length * 2.9;

          doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
          doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);
        }
      }
      doc.setFontSize(10);
      if (orderby2 == 3 || orderby2 == 2) {
        // doc.text('TEAM PLAYER LIST', 88, 45);
      } else {
        if (fontcolor == 0) {
          doc.setTextColor(196, 147, 14);
        } else {
          doc.setTextColor(22, 14, 117);
        }
        if (sts == 4 || sts == 5) {
          doc.text("UNSOLD PLAYER LIST", 85, 37);
        } else if (sts == 2 || sts == 6) {
          doc.text("AVAILABLE PLAYER LIST", 85, 37);
        } else {
          doc.text("AUCTION PLAYER LIST", 85, 37);
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        } else {
          doc.setTextColor(20, 14, 92);
        }
      }
      doc.setFontSize(16);

      var dumcatid = pdfdata[0].catid;
      var dumtid = pdfdata[0].tmid;

      if (pdflayouttype == "1") {
        pdfdownload2(pdfdata);
        return 0;
      }
      // //console.log('pdf player list.......')
      // //console.log(playerImagesBase64)
      // // //console.log(pdfdata)
      pdfdata.forEach((player, index) => {
        //// //console.log('player', player.detail);
        //  //// //console.log('player info')
        //  //// //console.log(player)
        // if (player.isnonplay == 1) {
        //   return null;
        // }
        if (count2 == 0) {
          if (orderby2 == 2) {
            //  //// //console.log('catdata')
            //  //// //console.log(catdata)
            if (generatecatid == "0") {
              // if (player.catid == "0") {
              var catname = "No category";
              // }
            } else {
              var catname = catdata?.filter((ct) => ct.cid == player.catid)[0]
                .cname;
            }
            const categoryText = catname.toUpperCase();
            const categoryTextWidth = doc.getTextWidth(categoryText);
            doc.text(
              categoryText,
              (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
              35
            );
            doc.setFontSize(8);
            const playerListText = "PLAYER LIST";
            const playerListTextWidth = doc.getTextWidth(playerListText);
            doc.text(
              playerListText,
              (doc.internal.pageSize.getWidth() - playerListTextWidth) / 2,
              40
            );
            doc.setFontSize(16);
          }
          if (orderby2 == 3) {
            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0]
              .name;
            const teamText = teamname.toUpperCase();
            const teamTextWidth = doc.getTextWidth(teamText);
            doc.text(
              teamText,
              (doc.internal.pageSize.getWidth() - teamTextWidth) / 2,
              35
            );
          }
        }

        if (orderby2 == 2) {
          if (dumcatid !== player.catid && isnocatshow && player.catid == "0") {
            dumcatid = player.catid;
            counter = 0;
            // x=10
            count2 = 0;

            doc.addPage();

            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);

            if (aucteambase64[2]) {
              doc.addImage(
                aucteambase64[2],
                "JPEG",
                1,
                1,
                doc.internal.pageSize.width - 2,
                doc.internal.pageSize.height - 2
              );
            } else {
              if (ispdfwhitebg == "1") {
                doc.addImage(
                  whitebg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              } else {
                doc.addImage(
                  pdfbg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              }
            }

            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], "JPEG", 10, 10, 40, 40);
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], "JPEG", 160, 10, 40, 40);
              } else {
                doc.addImage(aucteambase64[0], "JPEG", 160, 10, 40, 40);
              }
            } else {
              doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 40, 40);
              doc.addImage(auctiondefaultLogo, "JPEG", 160, 10, 40, 40);
            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            if (fontcolor == 0) {
              doc.setTextColor(255, 255, 255);
            } else {
              doc.setTextColor(20, 14, 92);
            }
            doc.setFontSize(18);

            if (acname.length < 27) {
              let alen = acname.length * 4;

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            } else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27);
              let alen1 = fstr[0].length * 3.2;

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9;

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);
              }
            }
            doc.setFontSize(16);
            // if (orderby2 == 3 || orderby2 == 2) {
            doc.text("No category", 90, 45);

            // } else {

            //   doc.text('AUCTION PLAYER LIST', 90, 40);
            // }
            // let clen = catname.length * 2;
            // doc.text(catname.toUpperCase(), 95 - clen / 2, 35);
            doc.setFontSize(8);
            const playerListText = "PLAYER LIST";
            const playerListTextWidth = doc.getTextWidth(playerListText);
            doc.text(
              playerListText,
              (doc.internal.pageSize.getWidth() - playerListTextWidth) / 2,
              40
            );
            doc.setFontSize(16);
            x = 10;
            y = 60;
          } else if (dumcatid !== player.catid) {
            // //  //// //console.log("cat change ")
            dumcatid = player.catid;
            counter = 0;
            // x=10
            count2 = 0;

            doc.addPage();

            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);

            var catname = catdata.filter((ct) => ct.cid == player.catid)[0]
              .cname;
            // //  //// //console.log('cathead')
            // //  //// //console.log(catname)

            // }
            // let x = 10;
            // let y = 60;
            // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[2]) {
              doc.addImage(
                aucteambase64[2],
                "JPEG",
                1,
                1,
                doc.internal.pageSize.width - 2,
                doc.internal.pageSize.height - 2
              );
            } else {
              if (ispdfwhitebg == "1") {
                doc.addImage(
                  whitebg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              } else {
                doc.addImage(
                  pdfbg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              }
            }

            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], "JPEG", 10, 10, 40, 40);
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], "JPEG", 160, 10, 40, 40);
              } else {
                doc.addImage(aucteambase64[0], "JPEG", 160, 10, 40, 40);
              }
            } else {
              doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 40, 40);
              doc.addImage(auctiondefaultLogo, "JPEG", 160, 10, 40, 40);
            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            if (fontcolor == 0) {
              doc.setTextColor(255, 255, 255);
            } else {
              doc.setTextColor(20, 14, 92);
            }
            doc.setFontSize(18);

            if (acname.length < 27) {
              let alen = acname.length * 4;

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            } else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27);
              let alen1 = fstr[0].length * 3.2;

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9;

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);
              }
            }
            doc.setFontSize(16);
            if (orderby2 == 3 || orderby2 == 2) {
              // doc.text('TEAM PLAYER LIST', 90, 45);
            } else {
              doc.text("AUCTION PLAYER LIST", 90, 40);
            }
            const categoryText = catname.toUpperCase();
            const categoryTextWidth = doc.getTextWidth(categoryText);
            doc.text(
              categoryText,
              (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
              35
            );
            doc.setFontSize(8);
            const playerListText = "PLAYER LIST";
            const playerListTextWidth = doc.getTextWidth(playerListText);
            doc.text(
              playerListText,
              (doc.internal.pageSize.getWidth() - playerListTextWidth) / 2,
              40
            );
            doc.setFontSize(16);
            x = 10;
            y = 60;
          }
        }
        if (orderby2 == 3) {
          // //  //// //console.log("team ki pdfff")

          if (dumtid !== player.tmid) {
            // //  //// //console.log("team change hui")
            dumtid = player.tmid;
            counter = 0;
            count2 = 0;

            doc.addPage();
            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);

            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0]
              .name;
            // doc.addImage(aucteambase64[player.tmid], 'JPEG', 75, 35, 15, 15);

            // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[2]) {
              doc.addImage(
                aucteambase64[2],
                "JPEG",
                1,
                1,
                doc.internal.pageSize.width - 2,
                doc.internal.pageSize.height - 2
              );
            } else {
              if (ispdfwhitebg == "1") {
                doc.addImage(
                  whitebg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              } else {
                doc.addImage(
                  pdfbg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              }
            }
            if (aucteambase64[0]) {
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], "JPEG", 160, 10, 40, 40);
              } else {
                doc.addImage(aucteambase64[0], "JPEG", 160, 10, 40, 40);
              }
            } else {
              doc.addImage(auctiondefaultLogo, "JPEG", 160, 10, 40, 40);
            }
            if (aucteambase64[player.tmid]) {
              doc.addImage(aucteambase64[player.tmid], "JPEG", 10, 10, 40, 40);
            } else {
              doc.addImage(teamdefaultLogo, "JPEG", 10, 10, 40, 40);
            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            if (fontcolor == 0) {
              doc.setTextColor(255, 255, 255);
            } else {
              doc.setTextColor(20, 14, 92);
            }
            doc.setFontSize(18);

            if (acname.length < 27) {
              let alen = acname.length * 4;

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            } else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27);
              let alen1 = fstr[0].length * 3.2;

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9;

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);
              }
            }
            doc.setFontSize(10);

            // doc.text('TEAM PLAYER LIST', 88, 45);
            doc.setFontSize(16);
            const teamText = teamname;
            const teamTextWidth = doc.getTextWidth(teamText);

            doc.text(
              teamText,
              (doc.internal.pageSize.getWidth() - teamTextWidth) / 2,
              35
            );
            // doc.addImage(auctiondefaultLogo, 'JPEG', 75, 45, 20, 20);
            x = 10;
            y = 60;
          }
        }
        if (column == 2) {
          if (counter % 2 && counter != 0) {
            x = x + rightbox;
          } else if (counter != 0) {
            y = y + bottombox;
            x = 10;
          }
        } else if (column == 3) {
          if (counter % 3 && counter != 0) {
            x = x + rightbox;
          } else if (counter != 0) {
            y = y + bottombox;
            x = 10;
            // //  //// //console.log("x to 0")
          }
        }

        // doc.setFillColor(255, 255, 255);

        doc.setDrawColor(232, 192, 84);

        doc.rect(x - 1, y - 1, rectwide, reactheight);

        // doc.setFillColor(5, 26, 66);

        // doc.rect(x - 1, y - 1, rectwide, reactheight, 'F');

        var imgindex = pldata?.list?.findIndex(
          (item) => item.pid === player.pid
        );

        doc.setDrawColor(252, 151, 28);
        doc.setFillColor(252, 151, 28);

        doc.rect(x - 0.5, y - 0.5, imgwidth + 1, imgheight + 1, "F");

        if (
          playerImagesBase64 &&
          playerImagesBase64[player.pid] &&
          playerImagesBase64[player.pid].startsWith("data:image")
        ) {
          doc.addImage(
            playerImagesBase64[player.pid],
            "PNG",
            x,
            y,
            imgwidth,
            imgheight
          );
        } else {
          doc.addImage(playerdefaultLogo, "PNG", x, y, imgwidth, imgheight);
        }
        if (player.ownertag != "0" && player.ownertag != 0) {
          // Prioritize cus_tag first, then ownertag
          let tagname = "";

          if (player.cus_tag && player.cus_tag.trim() !== "") {
            // Use custom tag if available
            tagname = player.cus_tag.trim();
          } else {
            // Otherwise use the owner tag name
            tagname = getTagName(player.ownertag);
          }

          if (tagname) {
            // Convert to uppercase
            tagname = tagname.toUpperCase();

            doc.setFontSize(6);
            doc.setFont("NotoSansGujarati-Regular", "bold");
            doc.setTextColor(255, 255, 255); // White text color

            // Calculate center position for the tag text
            const tagTextWidth = doc.getTextWidth(tagname);
            const centerX = x + (imgwidth / 2);
            const tagX = centerX - (tagTextWidth / 2);
            const tagY = y + imgheight; // Position just below the image

            // Try CMYK color for green
            doc.setFillColor(100, 0, 100, 0); // CMYK: C=100, M=0, Y=100, K=0 (Green)

            doc.roundedRect(
              tagX - 1,
              tagY - 2.5,
              tagTextWidth + 2,
              4,
              1,
              1,
              "F"
            );

            // Draw the tag text
            doc.text(tagname, tagX, tagY);

            // Reset font settings
            doc.setFontSize(10);
            doc.setFont("NotoSansGujarati-Regular", "normal");
          }
        }

        doc.setTextColor(255, 255, 255); // White color for text
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");

        doc.setFillColor(252, 151, 28);

        doc.rect(x - 2, y - 2, 4.5, 4.5, "F");

        doc.setFontSize(nameagefont);
        // doc.setFont('helvetica', 'bold');
        doc.setFont("NotoSansGujarati-Regular", "bold");
        //  //// //console.log('player name')
        //  //// //console.log(player.pname)
        // if (player.pname.length > 20) {
        //   doc.setFontSize(nameagefont - 1);

        //   doc.text(player.pname.slice(0, 20).toUpperCase() + '...', x + namex, y + namey - 1);
        // }
        // else if (player.pname.length > 18) {
        //   doc.text(player.pname.slice(0, 18).toUpperCase() + '...', x + namex, y + namey - 1);

        // }
        // else {
        //   doc.text(player.pname.toUpperCase(), x + namex, y + namey - 1);
        // }
        if (player.pname.length > 20) {
          doc.setFontSize(6);
        } else {
          doc.setFontSize(8);
        }

        doc.setFont("NotoSansGujarati-Regular", "normal");

        if (ispdfwhitebg == "1") {
          doc.setTextColor(20, 14, 92); // Blue color for white background
        } else {
          doc.setTextColor(255, 255, 255); // White color for normal background
        }


        doc.text(player.pname.toUpperCase(), x + namex, y + namey - 1);
        doc.setFontSize(10);

        if (isplnoshow) {
          //console.log("player.pcode......", player.pcode)
          const pcodeStr = String(player.pcode);

          if (pcodeStr.length == 1) {
            //console.log("player.pcode......111", player.pcode)

            doc.text(pcodeStr, x - 0.9, y + 1.3);
          } else if (pcodeStr.length == 2) {
            //console.log("player.pcode......2222", player.pcode)
            doc.setFontSize(8.5);

            doc.text(pcodeStr, x - 1.6, y + 1.3);
            doc.setFontSize(10);
          } else if (pcodeStr.length == 3) {
            doc.setFontSize(7);
            doc.text(pcodeStr, x - 1.8, y + 1.3);
            doc.setFontSize(10);
          }
        }
        // var pcodeStr = String(player.pcode);
        // console.log("pcodeStr", pcodeStr);

        // if ( player.ownertag != "0" && player.ownertag != 0) {
        //   doc.setFontSize(5);
        //   doc.setFont("NotoSansGujarati-Regular", "bold");

        //   var tagText = "";
        //   if (player.ownertag == 1) {
        //     tagText = "OWN";
        //   } else if (player.ownertag == "2") {
        //     tagText = "CO-OWN";
        //   } else if (player.ownertag == "3") {
        //     tagText = "CAPT";
        //   } else if (player.ownertag == "4") {
        //     tagText = "ICON";
        //   }

        //   if (tagText) {
        //     // Position tag next to or below player number
        //     if (pcodeStr.length >= 1) {
        //       doc.text(tagText, x + 4, y + 1.3);
        //     } else {
        //       doc.text(tagText, x + 2, y + 1.3);
        //     }
        //   }

        //   doc.setFont("NotoSansGujarati-Regular", "normal");
        //   doc.setFontSize(10);
        // }

        doc.setFontSize(nameagefont);

        // doc.setFont('helvetica', 'normal');
        doc.setFont("NotoSansGujarati-Regular", "normal");

        //Player age
        if (player.age !== "0" && player.age !== 0) {
          doc.setFontSize(6);
          // if (isplnoshow) {
          //   doc.text(`AGE: ${player.age} YR`, x + plnox + 4 + player.pcode.length, y + agey - 2.1);

          // }
          // else {

          doc.text(`AGE: ${player.age} YR`, x + plnox, y + agey - 1.1);
          // }
        }
        if (ismobnoshow && player.mob) {
          doc.setFontSize(6);

          doc.addImage(tele, "PNG", x + plnox + 20, y + agey - 4.5, 2.5, 2.5);
          doc.text(player.mob, x + plnox + 23, y + agey - 2.1);
        }
        doc.setTextColor(222, 235, 52);
        var ym = 3;
        if (player.age == "0") {
          var ym = 0;
        }

        // //// //console.log('///////////isval show........')
        // //// //console.log(isvalshow)
        if (
          (orderby2 == 3 || orderby2 == 1) &&
          isvalshow &&
          player.tmid != "0" &&
          player.tmid != ""
        ) {
          doc.setFontSize(10);
          if (fontcolor == 0) {
            doc.setTextColor(222, 235, 52);
          } else {
            doc.setTextColor(12, 79, 17);
          }
          if (currentauc.isdecm == "1") {
            doc.text(
              parseFloat(player.points).toFixed(2),
              x + plnox,
              y + agey + ym - 1
            );
            var temppx = player.points.length * 1.5;
          } else {
            doc.text(
              String(parseInt(player.points)),
              x + plnox,
              y + agey + ym - 1
            );
            var temppx = String(parseInt(player.points)).length * 2;
          }
          doc.setFontSize(6);
          if (currentauc?.unit != "" && currentauc?.unit != null) {
            doc.text(
              currentauc.unit + " POINTS",
              x + plnox + temppx,
              y + agey + ym - 1.5
            );
          } else {
            doc.text("POINTS", x + plnox + temppx + 1, y + agey + ym - 1.5);
          }
          // doc.text("Team :", x + plnox + temppx + 1, y + agey + ym - 1.5);
          if (fontcolor == 0) {
            doc.setTextColor(255, 255, 255);
          } else {
            doc.setTextColor(20, 14, 92);
          }
          if (colno == 1) {
            ym += 4.5;
          } else {
            ym += 3;
          }
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        } else {
          doc.setTextColor(20, 14, 92);
        }
        doc.setFontSize(6);

        if (isvalshow && String(player.tmid) != "0") {
          // //console.log("player.tmid", player.tmid)

          doc.text("SOLD TO :", x + plnox, y + agey + ym - 1);
          var pteam = dataTeam.filter((team) => team.tid == player.tmid)[0]
            ?.name;
          if (pteam) {
            doc.text(pteam.toUpperCase(), x + plnox + 11, y + agey + ym - 1);
          }
          ym += 2.2;
          // doc.addImage(soldstamp, 'JPEG', x + plnox + 27, y + agey + ym - 10, 10, 10);
        }
        if (isownershow && player.ownertag != "0") {
          doc.setFontSize(6);
          doc.setTextColor(222, 235, 52);

          var tag = "";
          if (player.ownertag == 1) {
            tag = "Owner";
          } else if (player.ownertag == "2") {
            tag = "Co-owner";
          } else if (player.ownertag == "3") {
            tag = "Captain";
          } else if (player.ownertag == "4") {
            tag = "Icon";
          }
          doc.text(tag, x + plnox, y + agey + ym - 1);
          ym += 2.2;
        }
        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        } else {
          doc.setTextColor(20, 14, 92);
        }
        if (
          player.catid !== "0" &&
          player.catid !== null &&
          iscatshow &&
          player.catid !== 0
        ) {
          doc.setFontSize(6);
          //console.log('player.catid.............................')
          //console.log(player.catid)
          //console.log('catdata.............................')
          //console.log(catdata)
          //console.log('player.............................')
          //console.log(player)
          //  //// //console.log("New player")

          var catname = catdata?.filter((ct) => ct.cid == player.catid)[0]
            ?.cname;
          //  //// //console.log('cats')
          //  //// //console.log(cats)
          if (catname) {
            doc.text(catname.toUpperCase(), x + plnox, y + agey + ym - 1);
          }

          // doc.text('Base price : '+ player.base + ' ' + isunit, x + plnox, y + agey + ym - 1);
          // //  //// //console.log(y + agey + ym - 1)
          ym += 2.2;
        }
        if (isbasePriceShow) {
          //  //// //console.log('player is')
          //  //// //console.log(player)
          var isunit = "";
          if (aucdata.list[0].unit != "" && aucdata.list[0].unit != null) {
            isunit = aucdata.list[0].unit;
          }
          if (catdata && catdata.length > 0) {
            var cats = catdata?.filter((ct) => ct.cid == player.catid)?.[0];
          }
          //console.log('cats is')
          //console.log(cats)

          if (
            player.base != "" &&
            player.base != null &&
            player.base != "0.00"
          ) {
            // //// //console.log('player base')
            doc.text(
              "Base price : " +
              parseFloat(player.base).toFixed(currentauc.isdecm) +
              " " +
              isunit,
              x + plnox,
              y + agey + ym - 1
            );
          } else if (
            cats &&
            cats?.mbid !== "" &&
            cats?.mbid != "0" &&
            cats?.mbid != "0.00"
          ) {
            // //// //console.log('cats mbid from cat')
            doc.text(
              "Base price : " +
              parseFloat(cats?.mbid).toFixed(currentauc.isdecm) +
              " " +
              isunit,
              x + plnox,
              y + agey + ym - 1
            );
          } else if (
            aucminbid != "" &&
            aucminbid != "0.00" &&
            aucminbid != null
          ) {
            // //// //console.log('aucminbid')
            doc.text(
              "Base price : " +
              parseFloat(aucminbid).toFixed(currentauc.isdecm) +
              " " +
              isunit,
              x + plnox,
              y + agey + ym - 1
            );
          }
          // else if()
          ym += 2.2;
        }
        if (fontcolor == 0) {
          doc.setTextColor(232, 209, 188);
        } else {
          doc.setTextColor(22, 14, 117);
        }

        if (istshirtshow && player.tshirt !== "" && player.tshirt !== null) {
          // //  //// //console.log(player.pname)
          // //  //// //console.log(player.name)
          istshirtshow && doc.setFontSize(5);

          doc.text("T-" + player.tshirt, x + plnox, y + agey + ym - 1);
          ym += 2.2;
        }

        doc.setFontSize(5.6);

        // doc.text(player.spcf1.toUpperCase(), x + spcfx, y + agey + ym - 1);

        if (
          player.spcf1 &&
          player.spcf1 != "" &&
          player.spcf1 != null &&
          isspec1
        ) {
          if (player.spcf1.length <= 28) {
            doc.text(player.spcf1.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {
            doc.setFontSize(5);

            var fstr = linechanger(player.spcf1, 29);

            doc.text(fstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;
        }

        //  //// //console.log("spcf2 me aaya")
        if (player.spcf2 && isspec2) {
          if (player.spcf2.length <= 28) {
            doc.text(player.spcf2.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {
            doc.setFontSize(5);

            var fsstr = linechanger(player.spcf2, 29);

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;
        }
        if (player.spcf3 && isspec3) {
          if (player.spcf3.length <= 28) {
            doc.text(player.spcf3.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {
            doc.setFontSize(4.5);

            var fsstr = linechanger(player.spcf3, 29);

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            if (fsstr[1].length < 29) {
              doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            } else {
              var fssstr = linechanger(fsstr[1], 29);
              doc.text(fssstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
              ym += 1.5;
              doc.text(fssstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            }
          }
          ym += 2.2;
        }
        if (player.detail && isdetailshow) {
          if (player.detail.length <= 28) {
            doc.text(player.detail.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {
            doc.setFontSize(4.5);

            var fsstr = linechanger(player.detail, 29);

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            if (fsstr[1].length < 29) {
              doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            } else {
              var fssstr = linechanger(fsstr[1], 29);
              doc.text(fssstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
              ym += 1.5;
              doc.text(fssstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            }
          }
          ym += 2.2;
        }

        counter = counter + 1;
        count2 = count2 + 1;

        if (fontcolor == 0) {
          doc.setTextColor(255, 255, 255);
        } else {
          doc.setTextColor(20, 14, 92);
        }
        if (count2 > perpage) {
          if (counter % (perpage + extra) == 0) {
            counter = 0;
            doc.addPage();
            // doc.addImage((aucmoredetail && aucmoredetail?.more[0]?.pdfbg) ? (aucmoredetail?.fpath + aucmoredetail?.more[0].pdfbg) : pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[2]) {
              doc.addImage(
                aucteambase64[2],
                "JPEG",
                1,
                1,
                doc.internal.pageSize.width - 2,
                doc.internal.pageSize.height - 2
              );
            } else {
              if (ispdfwhitebg == "1") {
                doc.addImage(
                  whitebg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              } else {
                doc.addImage(
                  pdfbg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              }
            }
            x = 10;
            y = 10;
          }
        } else {
          if (counter % perpage == 0) {
            counter = 0;
            doc.addPage();
            if (aucteambase64[2]) {
              doc.addImage(
                aucteambase64[2],
                "JPEG",
                1,
                1,
                doc.internal.pageSize.width - 2,
                doc.internal.pageSize.height - 2
              );
            } else {
              if (ispdfwhitebg == "1") {
                doc.addImage(
                  whitebg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              } else {
                doc.addImage(
                  pdfbg,
                  "JPEG",
                  1,
                  1,
                  doc.internal.pageSize.width - 2,
                  doc.internal.pageSize.height - 2
                );
              }
            }

            x = 10;
            y = 10;
          }
        }

        plno += 1;
      });

      setpdfclk(false);
      if (orderby2 == "" || orderby2 == 1) {
        doc.save(aid + "-" + acname.toUpperCase() + "_PLIST.pdf");
      }
      if (orderby2 == 2) {
        doc.save(aid + "-" + acname.toUpperCase() + "_PLIST_CATEGORY.pdf");
      }
      if (orderby2 == 3) {
        doc.save(aid + "-" + acname.toUpperCase() + "_PLIST_TEAM.pdf");
      }
    } else {
      alert("Data is empty !!");
    }
  }
  const firechange = (datasnap) => {
    //  //// //console.log("firechange");
    //  //// //console.log(datasnap);
    //  //// //console.log(getpageData)

    if (datasnap.type == "4" && datasnap.upd == "1" && getpageData != 0) {
      let responsedata = {};
      responsedata = {
        responsedata: {
          path: getpageData.responsedata.path,
          aid: aid,
          list: [datasnap.detail, ...getpageData.responsedata.list],
        },
      };
      //  //// //console.log(responsedata)
      setData(responsedata.responsedata);
      setplData(responsedata.responsedata);

      dispatch(playerlistData(responsedata));
    }
    if (datasnap.type == "4" && datasnap.upd == "2") {
      //  // //console.log("firechange edit")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.map((ele) => {
          if (ele.pid == datasnap.id) {
            return {
              ...ele, // Keep existing properties
              age: datasnap.detail.age,
              base: datasnap.detail.base,
              catid: datasnap.detail.catid,
              fname: datasnap.detail.fname,
              icons: datasnap.detail.icons,
              detail: datasnap.detail.detail,
              isnonplay: datasnap.detail.isnonplay,
              isowner: datasnap.detail.isowner,
              jrnm: datasnap.detail.jrnm,
              jrno: datasnap.detail.jrno,
              img: datasnap.detail.img,
              mob: datasnap.detail.mob,
              ownertag: datasnap.detail.ownertag,
              pcode: datasnap.detail.pcode,
              pid: datasnap.detail.pid,
              pname: datasnap.detail.pname,
              spcf1: datasnap.detail.spcf1,
              spcf2: datasnap.detail.spcf2,
              spcf3: datasnap.detail.spcf3,
              mob: datasnap.detail.mob,
              trouser: datasnap.detail.trouser,
              tshirt: datasnap.detail.tshirt,
            };
          }
          return ele; // Keep unchanged elements
        });

        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };

        setData(responsedata.responsedata);
        setplData(responsedata.responsedata);
        dispatch(playerlistData(responsedata));
      }
    }
    if (datasnap.type == "4" && datasnap.upd == "3") {
      //  //// //console.log("firechange del")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          return ele.pid != datasnap.id;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);
        setplData(responsedata.responsedata);

        dispatch(playerlistData(responsedata));
      }
    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
    if (
      (datasnap.type == "1" && datasnap.upd == "4") ||
      (datasnap.type == "3" && datasnap.upd == "4")
    ) {
      setData(getpageData.responsedata);
      setplData(getpageData.responsedata);
    }
  };
  function plfilter(customFilter = null) {
    // Determine which filter object to use
    // If a custom filter is passed (e.g., from clicking a duplicate item), use it.
    // Otherwise, use the current state 'filter'.
    const filterToUse = customFilter || filter;

    // Always dispatch filter to Redux regardless of filter state
    // We dispatch 'filter' (state) if no custom filter, or update redux with custom but 
    // usually we want to update the state as well if we are triggered by a click.
    // However, since handleDuplicateClick updates state AND calls this, 'filterToUse' 
    // might be slightly ahead or same as state.
    dispatch(playerfilter(filterToUse));

    // Safety check to ensure data is available
    if (
      !getpageData ||
      !getpageData.responsedata ||
      !getpageData.responsedata.list
    ) {
      return;
    }

    const filteredPlayers = getpageData.responsedata.list.filter((player) => {
      // Text search (name, player code, or mobile number)
      const matchesSearchText =
        filterToUse.searchText === "" ||
        (isNaN(filterToUse.searchText) &&
          player?.pname
            ?.toLowerCase()
            ?.includes(filterToUse.searchText?.toLowerCase())) ||
        (filterToUse.searchText?.length < 7 &&
          player?.pcode?.toString()?.includes(filterToUse.searchText)) ||
        (filterToUse.searchText?.length > 7 &&
          player?.mob &&
          player?.mob?.includes(filterToUse.searchText));

      // Status filtering
      const matchesStatus =
        filterToUse.selectedStatus === "" ||
        filterToUse.selectedStatus === "1" ||
        (filterToUse.selectedStatus === "5" && player.isskiped === 1) ||
        (filterToUse.selectedStatus === "6" && player.isowner !== 0) ||
        (filterToUse.selectedStatus === "4" && player.isfreez === 1) ||
        (filterToUse.selectedStatus === "2" && player.tmid === 0) ||
        (filterToUse.selectedStatus === "3" && player.tmid > 0);

      // Category filtering - if "1" (ALL) is selected or category matches
      const matchesCategory =
        filterToUse.selectedCategory === "1" ||
        String(player.catid) === filterToUse.selectedCategory;

      return matchesSearchText && matchesStatus && matchesCategory;
    });

    // Create response data object with filtered players
    var responsedata1 = {
      aid: getpageData.responsedata.aid,
      path: getpageData.responsedata.path,
      list: filteredPlayers,
    };

    // Update the UI with filtered data
    setData(responsedata1);

    // Check for duplicate player codes after filtering
    const filteredDuplicates = checkDuplicatePcodes(responsedata1.list);
    setDuplicatePcodes(filteredDuplicates);
  }

  const handleDuplicateClick = (searchText) => {
    if (!searchText) return;
    const newFilter = { ...filter, searchText: searchText };
    setFilter(newFilter);
    plfilter(newFilter);

    // Scroll to the filter input area so user sees the change
    const filterElement = document.querySelector('.plfilters');
    if (filterElement) {
      filterElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  useEffect(async () => {
    // //console.log('photos........useEffect.......................................................')
    // No longer automatically load player images on mount
    // Images will be loaded on-demand when generating PDFs
    //  //// //console.log('data badla h')
    //  //// //console.log(pldata)
  }, [pldata]);

  useEffect(() => {
    // if (cid == "37595" && !aucteambase64[2]) {
    //   setfontcolor("1");
    // } else {
    // setfontcolor("0");
    // }
  }, [cid, aucteambase64]);

  useEffect(() => {
    localStorage.removeItem("isFirstMount");
    // fetchReceiptList();

    if (aucdata == 0) {
      fetchaucData();
    }
    // if(getteampageData==0){
    fetchTeamData();
    // }
    fetchData();
    if (getpageData == 0) {
      fetchData();
    } else {
      console.log("setting players...");
      console.log(getpageData.responsedata.list);
      if (getpageData.responsedata.aid == aid) {
        // Don't set unfiltered data - plfilter() will handle it
        setplData(getpageData.responsedata);

        // Make sure receipt data is set even when using data from Redux
        if (
          getpageData.responsedata.receipts &&
          getpageData.responsedata.receipts.length > 0
        ) {
          setReceiptList(getpageData.responsedata.receipts);
          setreceiptpath(getpageData.responsedata.rpath);
        }
      } else {
        let responsedata = getpageData.responsedata;
        responsedata.list = [];
        setData(responsedata);
        setplData(responsedata);
        fetchData(0);
      }
    }
    if (getteampageData == 0) {
      fetchTeamData();
    }
    if (getcatpageData == 0) {
      fetchcatData();
    } else {
      setcatData(getcatpageData.responsedata.list);
    }

    setRenderCount((prevCount) => prevCount + 1);
    if (aucmoredetail) {
      if (aucmoredetail.spn?.length > 0) {
        setsponsorlogo(aucmoredetail.spath + aucmoredetail.spn[0].logo + "?c");
      }
      if (aucmoredetail.more?.length > 0) {
        setcusbg(aucmoredetail.fpath + aucmoredetail.more[0].pdfbg + "?c");
      }
    }
  }, []);
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  useEffect(() => {
    if (
      getpageData &&
      getpageData != 0 &&
      getpageData.responsedata &&
      getpageData.responsedata.list &&
      getpageData.responsedata.aid == aid
    ) {
      // Apply filter with preserved selectedCategory
      plfilter();
    }
  }, [getpageData, filter]);
  const fileToDataUri = (image) => {
    return new Promise((res) => {
      const reader = new FileReader();
      const { type, name, size } = image;
      reader.addEventListener("load", () => {
        res({
          base64: reader.result,
          name: name,
          type,
          size: size,
        });
      });
      reader.readAsDataURL(image);
    });
  };

  const base64 = async () => { };

  useEffect(() => {
    if (getfilters != 0) {
      //  //// //console.log('runningfilters')
      plfilter();
    }
    plfilter();
  }, [filter]);

  async function getpdf() {
    // Check if player images are loaded
    if (Object.keys(playerImagesBase64).length === 0) {
      setActive(true);
      // Create and add custom loading message overlay
      const loadingMsg = document.createElement("div");
      loadingMsg.id = "custom-loading-message";
      loadingMsg.innerHTML = "<div>Please wait, Processing data...</div>";
      loadingMsg.style.position = "fixed";
      loadingMsg.style.top = "50%";
      loadingMsg.style.left = "50%";
      loadingMsg.style.transform = "translate(-50%, -50%)";
      loadingMsg.style.padding = "20px";
      loadingMsg.style.background = "rgba(0,0,0,0.8)";
      loadingMsg.style.color = "white";
      loadingMsg.style.borderRadius = "8px";
      loadingMsg.style.zIndex = "10000";
      loadingMsg.style.fontSize = "16px";
      loadingMsg.style.fontWeight = "bold";
      document.body.appendChild(loadingMsg);

      try {
        await loadPlayerImages();
      } finally {
        // Remove custom loading message
        if (document.getElementById("custom-loading-message")) {
          document.body.removeChild(loadingMsg);
        }
        setActive(false);
      }
    }

    setpdfclk(true);
    // history.push('/players-pdf')
  }
  function excelclk() {
    setisexcelclk(true);
    // history.push('/players-pdf')
  }

  function exceldownload() {
    const showImage = admin_id ? isexcelimage : false;
    console.log("---------", admin_id)
    if (exceltype == 1 || exceltype == "") {
      var ar3 = [];
      var ar4 = [];
      // ar4.push(ele.id)
      {
        isexcelplno && ar4.push("P_no");
      }
      ar4.push("Name");
      {
        isexcelmob && ar4.push("Mobile");
      }
      {
        isexcelage && ar4.push("Age");
      }
      {
        isexceldob && ar4.push("Dob");
      }
      {
        isexcelcat && ar4.push("Category");
      }
      {
        isexcelsp1 && ar4.push("Specification 1");
      }
      {
        isexcelsp2 && ar4.push("Specification 2");
      }
      {
        isexcelsp3 && ar4.push("Specification 3");
      }
      {
        isexceltshirt && ar4.push("Tshirt");
      }
      {
        isexceltrouser && ar4.push("Trouser");
      }
      {
        isexceljname && ar4.push("Jersey_name");
      }
      {
        isexceljno && ar4.push("Jersey_no");
      }
      {
        isexcelbasebid && ar4.push("Base_bid");
      }
      {
        showImage && ar4.push("Image");
      }
      // Collect all unique custom fields from ALL players (not just first player)
      const allCustomFields = new Set();
      const orderedFields = [];
      
      if (data?.list && data.list.length > 0) {
        data.list.forEach((player) => {
          if (player.runwkt !== null && player.runwkt !== "" && player.runwkt !== "null") {
            try {
              const runwktData = JSON.parse(player.runwkt);
              
              if (Array.isArray(runwktData)) {
                runwktData.forEach((item) => {
                  const fieldName = item?.N?.trim();
                  if (fieldName) {
                    allCustomFields.add(fieldName);
                    // Add to orderedFields if not already present
                    // Include field if: not explicitly set to false in dynamicRunwktFields (default is true)
                    const isFieldEnabled = dynamicRunwktFields[fieldName] !== false;
                    if (!orderedFields.includes(fieldName) && isFieldEnabled) {
                      orderedFields.push(fieldName);
                    }
                  }
                });
              } else if (typeof runwktData === 'object' && runwktData !== null) {
                for (const key in runwktData) {
                  const fieldName = runwktData[key]?.N?.trim();
                  if (fieldName) {
                    allCustomFields.add(fieldName);
                    // Add to orderedFields if not already present
                    // Include field if: not explicitly set to false in dynamicRunwktFields (default is true)
                    const isFieldEnabled = dynamicRunwktFields[fieldName] !== false;
                    if (!orderedFields.includes(fieldName) && isFieldEnabled) {
                      orderedFields.push(fieldName);
                    }
                  }
                }
              }
            } catch (e) {
              console.error("runwkt parse error for player:", e, player);
            }
          }
        });
      }
      
      // Debug log to see what fields we found
      console.log("All custom fields found:", Array.from(allCustomFields));
      console.log("Ordered fields to add:", orderedFields);
      console.log("dynamicRunwktFields state:", dynamicRunwktFields);
      
      // Add all ordered fields to headers
      orderedFields.forEach((fieldName) => {
        ar4.push(fieldName);
      });
      {
        isexceldetail && ar4.push("Detail");
      }

      ar4.push();
      // ar3.push(ar2)
      // ar4.push("About")
      ar3.push(ar4);
      // var plcount=0;
      var data2 = data.list.forEach((ele) => {
        //  //// //console.log(ele)
        var ar2 = [];
        // ar2.push(ele.id)
        // if(ele.tmid=="0"){
        // plcount+=1

        {
          isexcelplno && ar2.push(ele.pcode);
        }
        ar2.push(ele.pname);
        {
          isexcelmob && ar2.push(ele.mob);
        }
        {
          isexcelage &&
            ar2.push(ele.age !== "0" && ele.age !== "" ? ele.age : "-");
        }
        {
          isexceldob && ar2.push(ele.dob);
        }
        if (isexcelcat == true) {
          if (
            ele.catid !== "0" &&
            ele.catid !== "" &&
            ele.catid !== undefined &&
            ele.catid !== 0
          ) {
            catdata?.filter((item) => {
              if (item.cid == ele.catid) {
                ar2.push(item.cname);
              }
            });
          } else {
            ar2.push("-");
          }
        }

        {
          isexcelsp1 && ar2.push(ele.spcf1 || "-");
        }
        {
          isexcelsp2 && ar2.push(ele.spcf2 || "-");
        }
        {
          isexcelsp3 && ar2.push(ele.spcf3 || "-");
        }
        {
          isexceltshirt && ar2.push(ele.tshirt || "-");
        }
        {
          isexceltrouser && ar2.push(ele.trouser || "-");
        }
        {
          isexceljname && ar2.push(ele.jrnm || "-");
        }
        {
          isexceljno && ar2.push(ele.jrno || "-");
        }
        {
          isexcelbasebid && ar2.push(ele.base || "-");
        }
        {
          showImage && ar2.push(data.path + ele.img);
        }

        // Add runwkt fields data in same order as headers (using orderedFields)
        if (orderedFields.length > 0) {
          try {
            var runwkt1 = ele.runwkt !== null && ele.runwkt !== "" ? JSON.parse(ele.runwkt) : null;
            
            // Use orderedFields to maintain column consistency
            orderedFields.forEach((fieldName) => {
              let value = "-";
              
              if (runwkt1) {
                if (Array.isArray(runwkt1)) {
                  const matchingField = runwkt1.find(f => f?.N?.trim() === fieldName);
                  if (matchingField) {
                    value = matchingField?.V || "-";
                  }
                } else if (typeof runwkt1 === 'object' && runwkt1 !== null) {
                  // Try to find by field name
                  const matchingKey = Object.keys(runwkt1).find(k => {
                    const item = runwkt1[k];
                    return (typeof item === 'object' && item?.N?.trim() === fieldName) || k === fieldName;
                  });
                  
                  if (matchingKey) {
                    const fieldData = runwkt1[matchingKey];
                    value = (typeof fieldData === 'object' && fieldData?.V !== undefined) 
                      ? fieldData.V 
                      : (fieldData !== null && fieldData !== undefined ? fieldData : "-");
                  }
                }
              }
              
              ar2.push(value);
            });
          } catch (e) {
            console.error("Error parsing runwkt in data row:", e);
            // If error, push "-" for all fields
            orderedFields.forEach(() => {
              ar2.push("-");
            });
          }
        }
        {
          isexceldetail && ar2.push(ele.detail || "-");
        }

        ar2.push();
        ar3.push(ar2);
        // }
      });
    } else if (exceltype == 2) {
      var ar3 = [];
      var ar4 = [];
      // ar4.push(ele.id)
      ar4.push("S_no");
      {
        isexcelplno && ar4.push("P_no");
      }
      ar4.push("Name");
      {
        isexcelmob && ar4.push("Mobile");
      }
      {
        isexcelage && ar4.push("Age");
      }
      {
        isexceldob && ar4.push("Dob");
      }
      {
        isexcelcat && ar4.push("Category");
      }
      {
        isexcelsp1 && ar4.push("Specification 1");
      }
      {
        isexcelsp2 && ar4.push("Specification 2");
      }
      {
        isexcelsp3 && ar4.push("Specification 3");
      }
      // ar4.push("WK")
      {
        isexceltshirt && ar4.push("Tshirt");
      }
      {
        isexceltrouser && ar4.push("Trouser");
      }
      {
        isexceljname && ar4.push("Jersey_name");
      }
      {
        isexceljno && ar4.push("Jersey_no");
      }
      {
        isexcelbasebid && ar4.push("Base_bid");
      }
      {
        showImage && ar4.push("Image");
      }
      // Collect all unique custom fields from ALL players (not just first player) - For Unsold Excel
      const allCustomFields2 = new Set();
      const orderedFields2 = [];
      if (data?.list && data.list.length > 0) {
        data.list.forEach((player) => {
          if (player.runwkt !== null && player.runwkt !== "") {
            try {
              const runwktData = JSON.parse(player.runwkt);
              
              if (Array.isArray(runwktData)) {
                runwktData.forEach((item) => {
                  const fieldName = item?.N?.trim();
                  if (fieldName) {
                    allCustomFields2.add(fieldName);
                    if (!orderedFields2.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
                      orderedFields2.push(fieldName);
                    }
                  }
                });
              } else if (typeof runwktData === 'object' && runwktData !== null) {
                for (const key in runwktData) {
                  const fieldName = runwktData[key]?.N?.trim();
                  if (fieldName) {
                    allCustomFields2.add(fieldName);
                    if (!orderedFields2.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
                      orderedFields2.push(fieldName);
                    }
                  }
                }
              }
            } catch (e) {
              console.error("runwkt parse error for player:", e);
            }
          }
        });
      }
      
      // Add any remaining fields
      allCustomFields2.forEach((fieldName) => {
        if (!orderedFields2.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
          orderedFields2.push(fieldName);
        }
      });
      
      // Add all ordered fields to headers
      orderedFields2.forEach((fieldName) => {
        ar4.push(fieldName);
      });
      {
        isexceldetail && ar4.push("Detail");
      }

      ar3.push(ar4);
      var plcount = 0;

      var data2 = data.list.forEach((ele) => {
        var ar2 = [];
        // ar2.push(ele.id)
        if (ele.tmid == "0") {
          plcount += 1;

          ar2.push(plcount);
          {
            isexcelplno && ar2.push(ele.pcode);
          }
          ar2.push(ele.pname);
          {
            isexcelmob && ar2.push(ele.mob);
          }
          {
            isexcelage &&
              ar2.push(ele.age !== "0" && ele.age !== "" ? ele.age : "-");
          }
          {
            isexceldob && ar2.push(ele.dob || "-");
          }
          if (isexcelcat == true) {
            if (
              ele.catid !== "0" &&
              ele.catid !== "" &&
              ele.catid !== undefined &&
              ele.catid !== 0
            ) {
              catdata?.filter((item) => {
                if (item.cid == ele.catid) {
                  ar2.push(item.cname);
                }
              });
            } else {
              ar2.push("-");
            }
          }

          {
            isexcelsp1 && ar2.push(ele.spcf1 || "-");
          }
          {
            isexcelsp2 && ar2.push(ele.spcf2 || "-");
          }
          {
            isexcelsp3 && ar2.push(ele.spcf3 || "-");
          }
          {
            isexceltshirt && ar2.push(ele.tshirt || "-");
          }
          {
            isexceltrouser && ar2.push(ele.trouser || "-");
          }
          {
            isexceljname && ar2.push(ele.jrnm || "-");
          }
          {
            isexceljno && ar2.push(ele.jrno || "-");
          }
          {
            isexcelbasebid && ar2.push(ele.base || "-");
          }
          {
            showImage && ar2.push(data.path + ele.img);
          }
          // Add runwkt fields data in same order as headers (using orderedFields2)
          if (orderedFields2.length > 0) {
            try {
              var runwkt1 = ele.runwkt !== null && ele.runwkt !== "" ? JSON.parse(ele.runwkt) : null;
              
              // Use orderedFields2 to maintain column consistency
              orderedFields2.forEach((fieldName) => {
                let value = "-";
                
                if (runwkt1) {
                  if (Array.isArray(runwkt1)) {
                    const matchingField = runwkt1.find(f => f?.N?.trim() === fieldName);
                    if (matchingField) {
                      value = matchingField?.V || "-";
                    }
                  } else if (typeof runwkt1 === 'object' && runwkt1 !== null) {
                    // Try to find by field name
                    const matchingKey = Object.keys(runwkt1).find(k => {
                      const item = runwkt1[k];
                      return (typeof item === 'object' && item?.N?.trim() === fieldName) || k === fieldName;
                    });
                    
                    if (matchingKey) {
                      const fieldData = runwkt1[matchingKey];
                      value = (typeof fieldData === 'object' && fieldData?.V !== undefined) 
                        ? fieldData.V 
                        : (fieldData !== null && fieldData !== undefined ? fieldData : "-");
                    }
                  }
                }
                
                ar2.push(value);
              });
            } catch (e) {
              console.error("Error parsing runwkt in data row:", e);
              // If error, push "-" for all fields
              orderedFields2.forEach(() => {
                ar2.push("-");
              });
            }
          }
          {
            isexceldetail && ar2.push(ele.detail || "-");
          }

          ar3.push(ar2);
        }
      });
    } else if (exceltype == 3) {
      fetchTeamData();
      fetchcatData();
      fetchData();
      var ar3 = [];
      var ar4 = [];
      ar4.push("SNo");
      {
        isexcelteam && ar4.push("Team");
      }
      {
        isexcelplno && ar4.push("P_No");
      }
      ar4.push("Name");
      {
        isexcelpoints && ar4.push("Points");
      }
      {
        isexcelmob && ar4.push("Mobile");
      }
      {
        isexcelage && ar4.push("Age");
      }
      {
        isexceldob && ar4.push("Dob");
      }
      {
        isexcelcat && ar4.push("Category");
      }
      {
        isexcelsp1 && ar4.push("Specification 1");
      }
      {
        isexcelsp2 && ar4.push("Specification 2");
      }
      {
        isexcelsp3 && ar4.push("Specification 3");
      }
      {
        isexcelfname && ar4.push("FName");
      }
      // ar4.push("Info")
      {
        isexceltshirt && ar4.push("TShirt");
      }
      {
        isexceltrouser && ar4.push("Trouser");
      }
      {
        isexceljname && ar4.push("Jersey_Name");
      }
      {
        isexceljno && ar4.push("Jersey_No.");
      }
      {
        isexcelbasebid && ar4.push("Base_bid");
      }
      {
        showImage && ar4.push("Image");
      }
      // Collect all unique custom fields from ALL players (not just first player) - For Final Excel
      const allCustomFields3 = new Set();
      const orderedFields3 = [];
      if (data?.list && data.list.length > 0) {
        data.list.forEach((player) => {
          if (player.runwkt !== null && player.runwkt !== "") {
            try {
              const runwktData = JSON.parse(player.runwkt);
              
              if (Array.isArray(runwktData)) {
                runwktData.forEach((item) => {
                  const fieldName = item?.N?.trim();
                  if (fieldName) {
                    allCustomFields3.add(fieldName);
                    if (!orderedFields3.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
                      orderedFields3.push(fieldName);
                    }
                  }
                });
              } else if (typeof runwktData === 'object' && runwktData !== null) {
                for (const key in runwktData) {
                  const fieldName = runwktData[key]?.N?.trim();
                  if (fieldName) {
                    allCustomFields3.add(fieldName);
                    if (!orderedFields3.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
                      orderedFields3.push(fieldName);
                    }
                  }
                }
              }
            } catch (e) {
              console.error("runwkt parse error for player:", e);
            }
          }
        });
      }
      
      // Add any remaining fields
      allCustomFields3.forEach((fieldName) => {
        if (!orderedFields3.includes(fieldName) && dynamicRunwktFields[fieldName] !== false) {
          orderedFields3.push(fieldName);
        }
      });
      
      // Add all ordered fields to headers
      orderedFields3.forEach((fieldName) => {
        ar4.push(fieldName);
      });
      {
        isexceldetail && ar4.push("Detail");
      }

      ar3.push(ar4);

      dataTeam.forEach((tm) => {
        var teamwise = [];
        teamwise = data.list.filter((dt) => dt.tmid == tm.tid);
        var sno = 1;
        teamwise.forEach((ele) => {
          //  //// //console.log(ele)
          var ar2 = [];
          ar2.push(sno);
          {
            isexcelteam && ar2.push(tm.name);
          }
          {
            isexcelplno && ar2.push(ele.pcode);
          }
          ar2.push(ele.pname);
          {
            isexcelpoints && ar2.push(ele.points);
          }
          {
            isexcelmob && ar2.push(ele.mob || "-");
          }
          {
            isexcelage &&
              ar2.push(ele.age !== "0" && ele.age !== "" ? ele.age : "-");
          }
          {
            isexceldob && ar2.push(ele.dob);
          }
          if (isexcelcat == true) {
            if (
              ele.catid !== "0" &&
              ele.catid !== "" &&
              ele.catid !== undefined &&
              ele.catid !== 0
            ) {
              //  //// //console.log(ele.catid)
              //  //// //console.log(catdata)
              var catname = catdata?.filter((ct) => ct.cid == ele.catid)[0]
                .cname;
              ar2.push(catname);
            } else {
              ar2.push("-");
            }
          }

          {
            isexcelsp1 && ar2.push(ele.spcf1);
          }
          {
            isexcelsp2 && ar2.push(ele.spcf2);
          }
          {
            isexcelsp3 && ar2.push(ele.spcf3);
          }
          {
            isexcelfname && ar2.push(ele.fname || "-");
          }
          {
            isexceltshirt && ar2.push(ele.tshirt || "-");
          }
          {
            isexceltrouser && ar2.push(ele.trouser || "-");
          }
          {
            isexceljname && ar2.push(ele.jrnm || "-");
          }
          {
            isexceljno && ar2.push(ele.jrno || "-");
          }
          {
            isexcelbasebid && ar2.push(ele.base);
          }

          {
            showImage && ar2.push(data.path + ele.img);
          }

          // Add runwkt fields data in same order as headers (using orderedFields3)
          if (orderedFields3.length > 0) {
            try {
              var runwkt1 = ele.runwkt !== null && ele.runwkt !== "" ? JSON.parse(ele.runwkt) : null;
              
              // Use orderedFields3 to maintain column consistency
              orderedFields3.forEach((fieldName) => {
                let value = "-";
                
                if (runwkt1) {
                  if (Array.isArray(runwkt1)) {
                    const matchingField = runwkt1.find(f => f?.N?.trim() === fieldName);
                    if (matchingField) {
                      value = matchingField?.V || "-";
                    }
                  } else if (typeof runwkt1 === 'object' && runwkt1 !== null) {
                    // Try to find by field name
                    const matchingKey = Object.keys(runwkt1).find(k => {
                      const item = runwkt1[k];
                      return (typeof item === 'object' && item?.N?.trim() === fieldName) || k === fieldName;
                    });
                    
                    if (matchingKey) {
                      const fieldData = runwkt1[matchingKey];
                      value = (typeof fieldData === 'object' && fieldData?.V !== undefined) 
                        ? fieldData.V 
                        : (fieldData !== null && fieldData !== undefined ? fieldData : "-");
                    }
                  }
                }
                
                ar2.push(value);
              });
            } catch (e) {
              console.error("Error parsing runwkt in data row:", e);
              // If error, push "-" for all fields
              orderedFields3.forEach(() => {
                ar2.push("-");
              });
            }
          }

          {
            isexceldetail && ar2.push(ele.detail || "-");
          }

          ar3.push(ar2);
          sno += 1;
        });
      });
    }

    const ws = XLSX.utils.aoa_to_sheet(ar3);
    const wb = XLSX.utils.book_new();

    // Set column widths
    const columnWidths = [];
    ar4.forEach((header, index) => {
      // Find maximum width needed for this column
      let maxWidth = header.length;

      // Check width needed for data in each row
      ar3.forEach((row) => {
        if (row[index]) {
          const cellLength = String(row[index]).length;
          maxWidth = Math.max(maxWidth, cellLength);
        }
      });

      // Set column width (add some padding)
      columnWidths[index] = { wch: maxWidth + 2 };
    });

    // Apply column widths
    ws["!cols"] = columnWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBlob = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    }
    const blob = new Blob([s2ab(excelBlob)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    //latest version of excel
    if (exceltype == 1) {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    } else if (exceltype == 2) {
      a.download = aid + "-" + acname + "_PLIST_UNSOLD.xlsx";
    } else if (exceltype == 3) {
      a.download = aid + "-" + acname + "_PLIST_FINAL.xlsx";
    } else {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    }
    a.click();
    if (exceltype == 3) {
      const db = getDatabase();

      var workhistory = {};
      var currentTime = new Date();
      workhistory["worktyp"] = "work11";
      workhistory["id"] = admin_id;
      workhistory["name"] = admin_name;
      workhistory["timestamp"] = currentTime.toISOString();
      workhistory["aname"] = acname;
      workhistory["aid"] = aid;
      push(ref(db, "map/info/workhistory"), workhistory)
        .catch((error) => {
          console.error("Error adding workhistory:", error);
        });
      var data1 = {};
      data1["work11"] = 3;
      update(ref(db, "map/info/datastatus/" + aid), data1)
        .catch((error) => {
          console.error("Error updating datastatus:", error);
        });
    }
  }
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
  };

  function setdata() {
    if (issetdata == false) {
      setissetdata(true);
    } else {
      setissetdata(false);
    }
  }
  function pdfcls() {
    setpdfclk(false);
  }
  function excelcls() {
    setisexcelclk(false);
  }
  function setorderdata(v) {
    setfilorder(v);
    // //  //// //console.log(pldata.list)
    if (v == "2") {
      var ordereddata = data.list.sort((a, b) => {
        return a.pname.localeCompare(b.pname, undefined, {
          sensitivity: "case",
        });
      });
    } else if (v == "" || v == "1") {
      // //  //// //console.log("ordereddata")
      // //  //// //console.log(getpageData.responsedata.list)
      var ordereddata = data.list.sort((a, b) => {
        return a.pcode - b.pcode;
      });
    }
  }
  function onKeyDownHandler(e) {
    if (e.keyCode === 13) {
      plfilter();
    }
  }

  const convertImageToBase64 = async (imageUrl, options = {}) => {
    const {
      maxWidth = 800, // Maximum width for regular image
      maxHeight = 800, // Maximum height for regular image
      quality = 0.7, // JPEG quality (0-1)
      roundedSize = 300, // Size for the rounded/circular image
      roundedQuality = 0.7, // Quality for rounded image
    } = options;

    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const img = await createImageBitmap(blob);

      const base64 = {};

      // Create optimized regular image
      const regularCanvas = document.createElement("canvas");
      const regularCtx = regularCanvas.getContext("2d");

      // Calculate dimensions while maintaining aspect ratio
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = Math.floor(height * (maxWidth / width));
        width = maxWidth;
      }

      if (height > maxHeight) {
        width = Math.floor(width * (maxHeight / height));
        height = maxHeight;
      }

      regularCanvas.width = width;
      regularCanvas.height = height;
      regularCtx.drawImage(img, 0, 0, width, height);

      // Get compressed regular image
      base64.regular = regularCanvas.toDataURL("image/jpeg", quality);

      // Create optimized rounded image
      const size = Math.min(roundedSize, img.width, img.height);
      const roundedCanvas = document.createElement("canvas");
      roundedCanvas.width = size;
      roundedCanvas.height = size;

      const roundedCtx = roundedCanvas.getContext("2d");

      // Draw circular clipping path
      roundedCtx.beginPath();
      roundedCtx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
      roundedCtx.closePath();
      roundedCtx.clip();

      // Draw the image centered inside the circular clipping path
      roundedCtx.drawImage(
        img,
        (img.width - size) / 2,
        (img.height - size) / 2,
        size,
        size,
        0,
        0,
        size,
        size
      );

      // Get compressed rounded image
      base64.rounded = roundedCanvas.toDataURL("image/png", roundedQuality);

      return base64;
    } catch (error) {
      console.error("Error converting image to base64:", error);
      return null;
    }
  };
  // const convertImageToBase64 = (img, index) => {
  //   const canvas = document.createElement('canvas');
  //   const ctx = canvas.getContext('2d');
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   // ctx.imageSmoothingEnabled = false; // Disable image smoothing
  //   ctx.drawImage(img, 0, 0, img.width, img.height);

  //   const base64Data = canvas.toDataURL('image/png');

  //   if (base64Data) {
  //     const newarr = base64Images;
  //     newarr[index] = base64Data
  //     setBase64Images(newarr);

  //   }
  //   const canvas2 = document.createElement('canvas');
  //   const ctx2 = canvas2.getContext('2d');
  //   canvas2.width = img.width;
  //   canvas2.height = img.height;
  //   ctx2.arc(img.width / 2, img.width / 2, img.width / 2, 0, Math.PI * 2, true);
  //   ctx2.clip();
  //   ctx2.drawImage(img, 0, 0, img.width, img.height);
  //   const roundbase64Data = canvas2.toDataURL('image/png', 1);
  //   if (roundbase64Data) {

  //     const newarr2 = roundbase64Images;
  //     newarr2[index] = roundbase64Data

  //     setroundBase64Images(newarr2);

  //   }

  // };
  const convertaucteamtobase64 = (img, index) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;

    ctx.drawImage(img, 0, 0, img.width, img.height);

    const base64Data2 = canvas.toDataURL("image/png");

    if (base64Data2) {
      const newarr2 = aucteambase64;
      newarr2[index] = base64Data2;
      //  //// //console.log(newarr2)
      setaucteambase64(newarr2);
    }
  };
  const handleImageLoad = (index) => {
    return () => {
      convertImageToBase64(imageRefs.current[index], index);
    };
  };
  const handleaucimgload = (index) => {
    return () => {
      convertaucteamtobase64(aucteamrefs.current[index], index);
    };
  };

  // const createClippingPath = (width, height, radius) => {
  //   const path = new Path();
  //   path.moveTo(radius, 0);
  //   path.arcTo(width - radius, 0, width, radius, radius);
  //   path.arcTo(width, height - radius, width - radius, height, radius);
  //   path.arcTo(radius, height, 0, height - radius, radius);
  //   path.arcTo(0, radius, radius, 0, radius);
  //   path.closePath();
  //   return path;
  // };
  function linechanger(str, count) {
    var plsp = str.split(" ");
    let plsplen = 0;
    let whichsp = 0;
    let firststr = "";
    let secstr = "";
    for (let i = 0; i < plsp.length; i++) {
      plsplen += plsp[i].length;

      if (plsplen > count) {
        break;
      }
      whichsp += 1;
    }
    var linearr = [];
    for (let y = 0; y < whichsp; y++) {
      if (firststr !== "") {
        firststr += " ";
      }
      firststr += plsp[y];
    }
    linearr.push(firststr);

    for (let z = whichsp; z < plsp.length; z++) {
      if (secstr !== "") {
        secstr += " ";
      }
      secstr += plsp[z];
    }
    linearr.push(secstr);
    return linearr;
  }
  const tagwisedownload = (playerlist) => {
    const doc = new jsPDF("p", "mm", "a4");

    // Prepare data
    var tagwisepdf = [];
    var tagplayercount = [];

    // Group players by team and filter by tags
    dataTeam.forEach((tm) => {
      var teamwise = data.list.filter((dt) => dt.isowner == tm.tid);
      var teamwisefiltered = [];

      // Collect all tagged players
      if (isownertagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "1"),
        ];
      }
      if (iscoownertagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "2"),
        ];
      }
      if (iscaptaintagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "3"),
        ];
      }
      if (isicontagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "4"),
        ];
      }
      if (isretaintagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "5"),
        ];
      }
      if (isvicecaptaintagselect) {
        teamwisefiltered = [
          ...teamwisefiltered,
          ...teamwise.filter((ele) => ele.ownertag == "6"),
        ];
      }
      // Sort players by pcode only
      teamwisefiltered.sort((a, b) => parseInt(a.pcode) - parseInt(b.pcode));

      if (teamwisefiltered.length > 0) {
        tagplayercount.push(teamwisefiltered.length);
        tagwisepdf.push({
          team: tm,
          players: teamwisefiltered,
        });
      }
    });

    // Determine layout mode
    const maxPlayersPerTeam = Math.max(...tagplayercount);
    const istwolane = maxPlayersPerTeam <= 2;

    // PDF generation constants
    var teamsPerPage = 6;
    if (istwolane) {
      teamsPerPage = 10;
    }
    const imageSize = istwolane ? 23 : 17;
    const spacing = istwolane ? 40 : 36;

    let pageCount = 0;

    // Process teams in groups of 6 (or 2x3 for two-lane mode)
    for (let teamIndex = 0; teamIndex < tagwisepdf.length; teamIndex++) {
      // Add new page if needed
      if (teamIndex % teamsPerPage === 0) {
        if (teamIndex > 0) {
          doc.addPage();
        }
        addPageHeader(doc);
        pageCount++;
      }

      const teamData = tagwisepdf[teamIndex];
      const pagePosition = teamIndex % teamsPerPage;

      // Calculate team position
      let baseY =
        70 +
        Math.floor(pagePosition / (istwolane ? 2 : 1)) * (istwolane ? 48 : 41);
      let baseX = istwolane ? (pagePosition % 2 === 0 ? 60 : 140) : 98;

      // Draw team name
      doc.setFontSize(12);
      doc.setTextColor(237, 215, 12);
      doc.setFont("helvetica", "bold");
      const teamName = teamData.team.name.toUpperCase();
      const teamNameWidth = teamName.length * 2;
      doc.text(teamName, baseX - teamNameWidth / 2, baseY - 20);

      // Calculate starting X for players based on count
      let playerBaseX = calculatePlayerStartX(
        teamData.players.length,
        baseX,
        istwolane
      );

      // Draw players
      teamData.players.forEach((player, playerIndex) => {
        //// //console.log('player')
        //// //console.log(player);
        const playerX =
          playerBaseX +
          playerIndex *
          (teamData.players.length >= 5
            ? 30
            : teamData.players.length === 4
              ? 33
              : 36);
        drawPlayer(
          doc,
          player,
          playerX,
          baseY,
          imageSize,
          teamData.players.length
        );
      });
    }

    doc.save(aid + "-" + acname.toUpperCase() + "_TAGLIST.pdf");
  };

  // Helper functions
  function addPageHeader(doc) {
    // Add background and logos
    doc.addImage(pdfbg, "JPEG", 0, 0, 210, 297);
    doc.addImage(pdfauctiontitlebg, "JPEG", 40, 10, 130, 20);

    if (aucteambase64[0]) {
      doc.addImage(aucteambase64[0], "JPEG", 10, 10, 20, 20);
      doc.addImage(aucteambase64[0], "JPEG", 175, 10, 20, 20);
    } else {
      doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 20, 20);
      doc.addImage(auctiondefaultLogo, "JPEG", 175, 10, 20, 20);
    }

    // Add auction name
    doc.setTextColor(255, 255, 255);
    if (acname.length < 27) {
      const alen = acname.length * 3.5;
      doc.text(acname.toUpperCase(), 105 - alen / 2, 22);
    } else {
      doc.setFontSize(15);
      var fstr = linechanger(acname, 27);
      let alen1 = fstr[0].length * 3.2;
      doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 20);
      if (fstr[1].length <= 25) {
        // //console.log('fstr[1].length <= 25')
        doc.setFontSize(11);
        let alen2 = fstr[1].length * 2.9;
        doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24.5);
      } else {
        // //console.log('fstr[1].length > 25')
        var fsstr = linechanger(fstr[1], 25);
        doc.setFontSize(14);
        let alen2 = fsstr[0].length * 2.9;
        let alen3 = fsstr[1].length * 2.9;
        doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
        doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);
      }
      // ... existing long name handling ...
    }
  }

  function calculatePlayerStartX(playerCount, baseX, istwolane) {
    if (istwolane) {
      return baseX - (playerCount === 1 ? 0 : 20);
    }

    // Adjust spacing based on player count
    let spacing;
    if (playerCount >= 5) {
      spacing = 30; // Reduced spacing for 5 or more players
    } else if (playerCount === 4) {
      spacing = 33; // Medium spacing for 4 players
    } else {
      spacing = 36; // Original spacing for 3 or fewer players
    }

    // Center players based on count and adjusted spacing
    const totalWidth = (playerCount - 1) * spacing;
    return baseX - totalWidth / 2;
  }

  function drawPlayer(doc, player, x, y, imageSize, playerCount) {
    const radius = imageSize / 2 + 3;
    const adjustCenter = imageSize / 2;

    // Adjust image size if there are many players
    const adjustedImageSize = playerCount >= 5 ? imageSize * 0.9 : imageSize;
    const adjustedRadius = adjustedImageSize / 2 + 3;

    // Draw circles
    doc.setDrawColor(165, 148, 247);
    doc.setLineWidth(1);
    doc.circle(x, y, adjustedImageSize / 2 + 0.2, "S");
    doc.setDrawColor(170, 180, 227);
    doc.setLineWidth(0.3);
    doc.circle(x, y, adjustedImageSize / 2 + 1.8, "S");

    // Add player image
    const plingindex = data.list.findIndex((elem) => elem.pid === player.pid);
    if (roundbase64Images[player.pid]) {
      doc.addImage(
        roundbase64Images[player.pid],
        "jpeg",
        x - adjustedImageSize / 2,
        y - adjustedImageSize / 2,
        adjustedImageSize,
        adjustedImageSize
      );
    }
    // else {
    //   doc.addImage(playerdefaultLogo, 'jpeg', x - adjustedImageSize / 2, y - adjustedImageSize / 2, adjustedImageSize, adjustedImageSize);
    // }

    // Add tag badge
    const badgeWidth = adjustedImageSize * 1.5;
    const badgeHeight = adjustedImageSize * 0.3;
    doc.addImage(
      tagbadge,
      "PNG",
      x - badgeWidth / 2,
      y + adjustedImageSize / 2 - badgeHeight / 2,
      badgeWidth,
      badgeHeight
    );

    // Draw player name in arc
    drawArcText(doc, player.pname, x, y, adjustedRadius);

    // Add tag name
    const tagname = getTagName(player.ownertag);
    doc.setFont("Courier", "bold");
    doc.setFontSize(playerCount >= 5 ? 6 : 7); // Smaller font for more players
    doc.text(
      tagname,
      x - (tagname.length / 2) * 1.4,
      y + (adjustedRadius - 2.7)
    );
  }
  const toppdfdownload = () => {
    fetchTeamData();
    if (getcatpageData == 0) {
      fetchcatData();
    }
    function linechanger(str, count) {
      var plsp = str.split(" ");
      let plsplen = 0;
      let whichsp = 0;
      let firststr = "";
      let secstr = "";
      for (let i = 0; i < plsp.length; i++) {
        plsplen += plsp[i].length;

        if (plsplen > count) {
          break;
        }
        whichsp += 1;
      }
      var linearr = [];
      for (let y = 0; y < whichsp; y++) {
        if (firststr !== "") {
          firststr += " ";
        }
        firststr += plsp[y];
      }
      linearr.push(firststr);

      for (let z = whichsp; z < plsp.length; z++) {
        if (secstr !== "") {
          secstr += " ";
        }
        secstr += plsp[z];
      }
      linearr.push(secstr);
      return linearr;
    }
    const doc = new jsPDF();
    let shouldBreak = false;
    let plcount = 0;
    //  //// //console.log('data.list')
    //  //// //console.log(data.list)
    var playersData = data.list;
    if (toppltype === "2" && catdata !== "" && catdata !== null) {
      var catwisefull = [];

      catdata.forEach((ct) => {
        var catwise = [];
        catwise = data.list.filter((dt) => dt.catid == ct.cid);
        if (catwise.length > 0) {
          catwise = [...catwise].sort((a, b) => b.points - a.points);
          catwise = catwise.slice(0, topnum);

          catwise.forEach((ele) => {
            catwisefull.push(ele);
          });
        }
      });
      //// //console.log('catwisefull')
      //// //console.log(catwisefull)
      playersData = catwisefull;
    }
    let soldplayers = [];
    if (ignoretype == "") {
      soldplayers = playersData.filter((ele) => ele.tmid > 0);
    } else if (ignoretype == "retain") {
      soldplayers = playersData.filter(
        (ele) => ele.tmid > 0 && ele.isfreez !== "1"
      );
    } else if (ignoretype == "cat") {
      soldplayers = playersData.filter(
        (ele) => ele.tmid > 0 && ele.catid !== String(ignorecat)
      );
    } else if (ignoretype == "tag") {
      soldplayers = playersData.filter(
        (ele) => ele.tmid > 0 && ele.ownertag !== ignoretag
      );
    } else if (ignoretype == "plno") {
      let igids = ignoreplnos.split(",");
      //  //// //console.log(igids)
      soldplayers = playersData.filter(
        (ele) => ele.tmid > 0 && !igids.includes(ele.pcode)
      );
    }
    //// //console.log('soldplayers')
    //// //console.log(soldplayers)
    //  //// //console.log(soldplayers)
    var topplayers = [];
    if (toppltype !== "2") {
      const sortedData = [...soldplayers].sort((a, b) => b.points - a.points);
      topplayers = sortedData.slice(0, topnum);
    } else {
      topplayers = soldplayers;
    }
    //  //// //console.log('topplayers');
    //  //// //console.log(topplayers);
    if (topplayers.length == 0 || topplayers.length < topnum) {
      alert("Cannot find " + topnum + " sold players !!");
      return 0;
    }

    if (toptype !== "0" || topnum == 1) {
      topplayers.map((ele, i) => {
        //  //// //console.log('player element')
        //  //// //console.log(ele)
        // if (ele.tmid > 0) {
        //   plcount += 1
        // }
        const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid);
        if (
          playerImagesBase64 &&
          playerImagesBase64[ele.pid] &&
          playerImagesBase64[ele.pid].startsWith("data:image")
        ) {
          doc.addImage(playerImagesBase64[ele.pid], "JPEG", 65, 95, 82, 82);
        } else {
          doc.addImage(playerdefaultLogo, "JPEG", 65, 95, 82, 82);
        }
        doc.addImage(
          bgtop1,
          "JPEG",
          1,
          1,
          doc.internal.pageSize.width - 2,
          doc.internal.pageSize.height - 2
        );
        doc.addImage(toplprofile, "JPEG", 26, 60, 160, 160);

        if (aucteambase64[0]) {
          doc.addImage(aucteambase64[0], "JPEG", 10, 20, 40, 40);
          doc.addImage(aucteambase64[0], "JPEG", 160, 20, 40, 40);
        } else {
          doc.addImage(auctiondefaultLogo, "JPEG", 10, 20, 40, 40);
          doc.addImage(auctiondefaultLogo, "JPEG", 160, 20, 40, 40);
        }
        doc.addImage(ribbin3, "PNG", 5, -10, 200, 40);
        doc.setTextColor(34, 46, 94);

        if (acname.length < 27) {
          let alen = acname.length * 3.5;
          doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
        } else {
          doc.setFontSize(15);

          var fstr = linechanger(acname, 27);
          let alen1 = fstr[0].length * 3.2;

          doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
          if (fstr[1].length <= 25) {
            doc.setFontSize(14);

            let alen2 = fstr[1].length * 2.9;

            doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
          } else {
            var fsstr = linechanger(fstr[1], 25);
            doc.setFontSize(14);

            let alen2 = fsstr[0].length * 2.9;
            let alen3 = fsstr[1].length * 2.9;
            doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
            doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);
          }
        }

        doc.addImage(ribbin, "PNG", 55, 27, 100, 15);
        doc.addImage(rankbadge, "PNG", 35, 75, 25, 25);
        doc.setFont("helvetica", "bold");

        doc.setFontSize(24);
        doc.setTextColor(173, 33, 26);

        doc.text(String(i + 1), 45, 90);

        // doc.addImage(ribinfo, 'PNG', 45, 200, 100, 20);

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);

        doc.text("TOP PLAYERS", 88, 33);
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20);
        let pnlen = ele.pname.length * 4.5;
        doc.setFont("helvetica", "bold");

        doc.text(ele.pname.toUpperCase(), 105 - pnlen / 2, 183);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(171, 188, 235);
        doc.setFontSize(26);
        doc.text("A U C T I O N", 79, 238);
        doc.setFontSize(16);
        var dateObj = new Date(aucdate);

        // Define months array
        var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        // Extract day, month, and year
        var day = dateObj.getDate();
        var monthIndex = dateObj.getMonth();
        var year = dateObj.getFullYear();

        // Format the date
        var formattedDate =
          day + " " + months[monthIndex].slice(0, 3) + " " + year;

        doc.text(formattedDate, 91, 247);
        doc.setFont("helvetica", "bold");
        var tplen = String(parseFloat(ele.points));

        var plen = tplen.length * 4;
        //  //// //console.log('plen')
        //  //// //console.log(plen)

        doc.text(
          String(parseFloat(ele.points)) + " POINTS",
          97 - plen / 2,
          203
        );

        doc.setTextColor(247, 183, 35);
        doc.setFont("helvetica", "bold");

        //  //// //console.log('ele.tmid')
        //  //// //console.log(ele.tmid)
        //  //// //console.log(dataTeam)

        if (dataTeam.length > 0 && ele.tmid > 0) {
          //  //// //console.log('data team ')
          //  //// //console.log(dataTeam)
          var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
        } else {
          var teamname = "";
        }
        var tnlen = teamname.length * 4;
        doc.text(
          String("TEAM : " + teamname.toUpperCase()),
          97 - tnlen / 2,
          210
        );

        if (i == topnum - 1) {
          return true;
        }
        doc.addPage();
      });
    }
    ///////////////////////////single page pdf/////////////////////////
    else {
      //  //// //console.log('single page pdf')

      doc.addImage(
        pdfbg,
        "JPEG",
        1,
        1,
        doc.internal.pageSize.width - 2,
        doc.internal.pageSize.height - 2
      );

      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], "JPEG", 10, 20, 40, 40);
        doc.addImage(aucteambase64[0], "JPEG", 160, 20, 40, 40);
      } else {
        doc.addImage(auctiondefaultLogo, "JPEG", 10, 20, 40, 40);
        doc.addImage(auctiondefaultLogo, "JPEG", 160, 20, 40, 40);
      }
      doc.addImage(ribbin3, "PNG", 5, -10, 200, 40);
      doc.setTextColor(34, 46, 94);

      if (acname.length < 27) {
        let alen = acname.length * 3.5;
        doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
      } else {
        doc.setFontSize(15);
        var fstr = linechanger(acname, 27);
        let alen1 = fstr[0].length * 3.2;
        doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
        if (fstr[1].length <= 25) {
          doc.setFontSize(14);
          let alen2 = fstr[1].length * 2.9;
          doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
        } else {
          var fsstr = linechanger(fstr[1], 25);
          doc.setFontSize(14);
          let alen2 = fsstr[0].length * 2.9;
          let alen3 = fsstr[1].length * 2.9;
          doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
          doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);
        }
      }
      doc.addImage(ribbin, "PNG", 55, 27, 100, 15);
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(14);
      doc.text("TOP PLAYERS", 88, 33);

      if (toppltype == "2") {
        var catname = catdata?.filter((ct) => ct.cid == topplayers[0].catid)[0]
          .cname;
        const categoryText = catname.toUpperCase();
        const categoryTextWidth = doc.getTextWidth(categoryText);
        doc.text(
          categoryText,
          (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
          24
        );
      }
      var imageX = 0;
      var imageY = 0;
      var imagesize = 0;
      if (topnum == 2 || topnum == 3) {
        imageX = 78;
        imageY = 75;
        imagesize = 50;
      } else if (topnum == 4) {
        imageX = 30;
        imageY = 75;
        imagesize = 50;
      } else if (topnum == 5) {
        imageX = 85;
        imageY = 65;
        imagesize = 40;
      } else if (topnum == 6) {
        imageX = 30;
        imageY = 70;
        imagesize = 40;
      } else if (topnum == 7) {
        imageX = 90;
        imageY = 65;
        imagesize = 30;
      } else if (topnum == 8) {
        imageX = 90;
        imageY = 55;
        imagesize = 25;
      } else if (topnum == 9) {
        imageX = 30;
        imageY = 75;
        imagesize = 25;
      } else if (topnum == 10) {
        imageX = 90;
        imageY = 55;
        imagesize = 30;
      } else if (topnum == 11) {
        imageX = 65;
        imageY = 65;
        imagesize = 25;
      } else if (topnum == 12) {
        imageX = 30;
        imageY = 65;
        imagesize = 25;
      } else if (topnum == 15) {
        // Fixed: 3-column layout with 5 rows
        imageX = 20;  // Start from left margin
        imageY = 50;  // Adjusted Y position for better fit
        imagesize = 35; // Slightly larger size for visibility
      } else if (topnum == 20) {
        // Fixed: 4-column layout with 5 rows
        imageX = 15;  // Start from left margin
        imageY = 50;  // Adjusted Y position
        imagesize = 30; // Adjusted size for 4 columns
      }
      var plcounter = 0;
      var plcounter2 = 0;
      //// //console.log('topplayers')
      //// //console.log(topplayers)
      topplayers.map((ele, i) => {
        if (toppltype == "2") {
          i = plcounter;
        }
        if (topnum != 10 && topnum != 8) {
          const plingindex = data.list.findIndex(
            (elem) => elem.pid === ele.pid
          );
          if (roundbase64Images[ele.pid]) {
            doc.addImage(
              roundbase64Images[ele.pid],
              "jpeg",
              imageX,
              imageY,
              imagesize,
              imagesize
            );
          }
          // else {
          //   doc.addImage(playerdefaultLogo, 'jpeg', imageX, imageY, imagesize, imagesize);
          // }
        }
        if (topnum == 2) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 10,
            imageY - 10,
            imagesize + 20,
            imagesize + 20
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2,
            imageY + imagesize - 1
          );
          doc.setTextColor(245, 175, 54);

          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.2,
            imageY + imagesize + 13
          );
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - ele.points.length * 1.4,
            imageY + imagesize + 20
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - teamname.length * 1.4,
              imageY + imagesize + 25
            );
          }
          imageY += 100;
        }
        if (topnum == 3) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 10,
            imageY - 10,
            imagesize + 20,
            imagesize + 20
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2,
            imageY + imagesize - 1
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 2.1,
            imageY + imagesize + 13
          );
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 20
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 25
            );
          }
          if (i == 0) {
            imageY += 90;
            imageX -= 50;
          } else {
            imageX += 100;
          }
        }
        if (topnum == 4) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 10,
            imageY - 10,
            imagesize + 20,
            imagesize + 20
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(20);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2,
            imageY + imagesize - 1
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 2.1,
            imageY + imagesize + 13
          );
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 20
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 25
            );
          }
          if (i % 2 == 0 || i == 0) {
            imageX += 100;
          } else {
            imageX = 30;
            imageY += 100;
          }
        }
        if (topnum == 5) {
          // if(i==0){
          //   imagesize=45;
          // }
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 8,
            imageY - 8,
            imagesize + 16,
            imagesize + 17
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(16);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 0.5,
            imageY + imagesize
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.7,
            imageY + imagesize + 13
          );
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) +
            (currentauc?.unit !== null ? currentauc?.unit : "") +
            " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 20
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 25
            );
          }
          if (i == 0) {
            imageX = 20;
            imageY += 55;
          } else if (i % 2 == 0) {
            imageX = 20;
            imageY += 85;
          } else {
            imageX += 130;
          }
        }
        if (topnum == 6) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 8,
            imageY - 8,
            imagesize + 16,
            imagesize + 17
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(16);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 0.5,
            imageY + imagesize
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.7,
            imageY + imagesize + 13
          );
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 20
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 25
            );
          }
          if (i % 2 == 0 || i == 0) {
            imageX += 110;
          } else {
            imageX = 30;
            imageY += 75;
          }
        }
        if (topnum == 7) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 7,
            imageY - 7,
            imagesize + 14,
            imagesize + 15
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 0.5,
            imageY + imagesize + 1
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 11
          );
          doc.setFontSize(10);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 17
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 22
            );
          }
          if (i == 0) {
            imageX = 30;
            imageY += 40;
          } else if (i % 2 == 0) {
            imageX = 30;
            imageY += 65;
          } else {
            imageX += 120;
          }
        }
        if (topnum == 8) {
          let rank = i + 1;
          if (i == 2) {
            ele = topplayers[i + 1];
            rank = 4;
          } else if (i == 3) {
            ele = topplayers[i - 1];
            rank = 3;
          }
          const plingindex = data.list.findIndex(
            (elem) => elem.pid === ele.pid
          );
          if (roundbase64Images[ele.pid]) {
            doc.addImage(
              roundbase64Images[ele.pid],
              "jpeg",
              imageX,
              imageY,
              imagesize,
              imagesize
            );
          }
          // else {
          //   doc.addImage(playerdefaultLogo, 'jpeg', imageX, imageY, imagesize, imagesize);
          // }
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 9.5
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(rank),
            imageX + imagesize / 2 - 0.5,
            imageY + imagesize
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 9
          );
          doc.setFontSize(10);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.9,
            imageY + imagesize + 15
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8),
              imageY + imagesize + 20
            );
          }
          if (i == 0) {
            // for first
            imageX = 30;
            imageY += 35;
          } else if (i == 1) {
            // after first column
            imageX += 60;
            imageY += 18;
          } else if (i == 2) {
            imageX += 60;
            imageY -= 18;
          } else if (i % 2 !== 0) {
            imageX = 30;
            imageY += 65;
          } else {
            imageX += 120;
          }
        }
        if (topnum == 9) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 9.5
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 1.5,
            imageY + imagesize - 0.5
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 9
          );
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.7,
            imageY + imagesize + 15
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8) * 0.8,
              imageY + imagesize + 19
            );
          }
          if ((i + 1) % 3 == 0) {
            imageX = 30;
            imageY += 65;
          } else {
            imageX += 65;
          }
        }
        if (topnum == 10) {
          let rank = i + 1;
          if (i == 2) {
            ele = topplayers[i + 1];
            rank = 4;
          } else if (i == 3) {
            ele = topplayers[i - 1];
            rank = 3;
          }
          const plingindex = data.list.findIndex(
            (elem) => elem.pid === ele.pid
          );
          if (roundbase64Images[ele.pid]) {
            doc.addImage(
              roundbase64Images[ele.pid],
              "jpeg",
              imageX,
              imageY,
              imagesize,
              imagesize
            );
          }
          // else {
          //   doc.addImage(playerdefaultLogo, 'jpeg', imageX, imageY, imagesize, imagesize);
          // }
          // //  //// //console.log(i)
          // //  //// //console.log(ele)
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 10.5
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(rank),
            imageX + imagesize / 2 - 1.5,
            imageY + imagesize - 1.5
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 8
          );
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.7,
            imageY + imagesize + 13
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8) * 0.8,
              imageY + imagesize + 17
            );
          }
          if (i == 0) {
            // for first
            imageX = 30;
            imageY += 35;
          } else if (i % 3 == 0) {
            // after last
            imageX = 30;
            imageY += 65;
          } else if ((i + 1) % 3 == 0) {
            // after middle
            imageX += 60;
            imageY -= 18;
          } else if ((i + 2) % 3 == 0) {
            // after first column
            imageX += 60;
            imageY += 18;
          }
        }
        if (topnum == 11) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 9.5
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 1.5,
            imageY + imagesize - 0.5
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 9
          );
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.7,
            imageY + imagesize + 15
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8) * 0.8,
              imageY + imagesize + 19
            );
          }
          if (i == 0) {
            imageX += 65;
          } else if ((i - 1) % 3 == 0) {
            imageX = 30;
            imageY += 55;
          } else {
            imageX += 65;
          }
        }
        if (topnum == 12) {
          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 9.5
          );
          // doc.addImage(rankbadge, 'PNG', imageX + imagesize/2 -5,imageY +imagesize-10, 10, 10);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 1.5,
            imageY + imagesize - 0.5
          );
          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - ele.pname.length * 1.4,
            imageY + imagesize + 9
          );
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + currentauc?.unit + " POINTS",
            imageX + imagesize / 2 - (ele.points.length + 5) * 0.7,
            imageY + imagesize + 15
          );
          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0].name;
            doc.text(
              String("TEAM : " + teamname.toUpperCase()),
              imageX + imagesize / 2 - (teamname.length + 8) * 0.8,
              imageY + imagesize + 19
            );
          }
          if ((i + 1) % 3 == 0) {
            imageX = 30;
            imageY += 55;
          } else {
            imageX += 65;
          }
        }
        if (topnum == 15) {
          // Load player image if available
          const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid);
          if (roundbase64Images[ele.pid]) {
            doc.addImage(
              roundbase64Images[ele.pid],
              "jpeg",
              imageX,
              imageY,
              imagesize,
              imagesize
            );
          }

          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 5,
            imageY - 5,
            imagesize + 9,
            imagesize + 9.5
          );

          doc.setFont("helvetica", "bold");
          doc.setFontSize(10); // Reduced font size
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 3,
            imageY + imagesize - 2
          );

          doc.setTextColor(245, 175, 54);
          doc.text(
            ele.pname,
            imageX + imagesize / 2 - (ele.pname.length * 0.7),
            imageY + imagesize + 8
          );

          doc.setFontSize(7); // Further reduced for points
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          doc.text(
            String(parseFloat(ele.points)) + (currentauc?.unit || "") + " PTS",
            imageX + imagesize / 2 - ((String(ele.points).length + 5) * 0.5),
            imageY + imagesize + 13
          );

          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0]?.name || "";
            if (teamname) {
              // Shorten team name if too long
              let displayTeamName = teamname.length > 8 ? teamname.substring(0, 8) + ".." : teamname;
              doc.text(
                String("TEAM: " + displayTeamName.toUpperCase()),
                imageX + imagesize / 2 - ((displayTeamName.length + 6) * 0.6),
                imageY + imagesize + 18
              );
            }
          }

          // 3-column layout: reset X after every 3 items
          if ((i + 1) % 3 == 0) {
            imageX = 20;
            imageY += 55;
          } else {
            imageX += 65;
          }
        }

        // Update topnum=20 case:
        if (topnum == 20) {
          // Load player image if available
          const plingindex = data.list.findIndex((elem) => elem.pid === ele.pid);
          if (roundbase64Images[ele.pid]) {
            doc.addImage(
              roundbase64Images[ele.pid],
              "jpeg",
              imageX,
              imageY,
              imagesize,
              imagesize
            );
          }

          doc.addImage(
            topborderirng,
            "jpeg",
            imageX - 4,
            imageY - 4,
            imagesize + 7,
            imagesize + 7.5
          );

          doc.setFont("helvetica", "bold");
          doc.setFontSize(9); // Smaller font for 4 columns
          doc.setTextColor(255, 255, 255);
          doc.text(
            String(i + 1),
            imageX + imagesize / 2 - 2.5,
            imageY + imagesize - 2
          );

          doc.setTextColor(245, 175, 54);
          // Shorten name if too long
          let displayName = ele.pname.length > 10 ? ele.pname.substring(0, 10) + ".." : ele.pname;
          doc.text(
            displayName,
            imageX + imagesize / 2 - (displayName.length * 0.6),
            imageY + imagesize + 7
          );

          doc.setFontSize(6); // Very small for points
          doc.setTextColor(255, 255, 255);
          doc.setFont("helvetica", "normal");
          let pointsText = String(parseFloat(ele.points)) + (currentauc?.unit || "") + "P";
          doc.text(
            pointsText,
            imageX + imagesize / 2 - (pointsText.length * 0.5),
            imageY + imagesize + 12
          );

          if (dataTeam.length > 0 && ele.tmid > 0) {
            var teamname = dataTeam.filter((tm) => tm.tid == ele.tmid)[0]?.name || "";
            if (teamname) {
              // Shorten team name to initials
              let teamInitials = teamname.split(' ').map(word => word[0]).join('').toUpperCase();
              teamInitials = teamInitials.substring(0, 3); // Max 3 chars
              // doc.text(
              //   String("T: " + teamInitials),
              //   imageX + imagesize / 2 - ((teamInitials.length + 2) * 0.5),
              //   imageY + imagesize + 16
              // );
            }
          }

          // 4-column layout: reset X after every 4 items
          if ((i + 1) % 4 == 0) {
            imageX = 15;
            imageY += 50;
          } else {
            imageX += 47; // Adjusted spacing for 4 columns
          }
        }
        plcounter += 1;
        plcounter2 += 1;
        if (toppltype == "2") {
          if ((i + 1) % topnum == 0 && topplayers.length > plcounter2) {
            //// //console.log(i)
            doc.addPage();
            plcounter = 0;
            doc.addImage(
              pdfbg,
              "JPEG",
              1,
              1,
              doc.internal.pageSize.width - 2,
              doc.internal.pageSize.height - 2
            );

            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], "JPEG", 10, 20, 40, 40);
              doc.addImage(aucteambase64[0], "JPEG", 160, 20, 40, 40);
            } else {
              doc.addImage(auctiondefaultLogo, "JPEG", 10, 20, 40, 40);
              doc.addImage(auctiondefaultLogo, "JPEG", 160, 20, 40, 40);
            }
            doc.addImage(ribbin3, "PNG", 5, -10, 200, 40);
            doc.setTextColor(34, 46, 94);

            if (acname.length < 27) {
              let alen = acname.length * 3.5;
              doc.text(acname.toUpperCase(), 105 - alen / 2, 12);
            } else {
              doc.setFontSize(15);
              var fstr = linechanger(acname, 27);
              let alen1 = fstr[0].length * 3.2;
              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 10);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);
                let alen2 = fstr[1].length * 2.9;
                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 15);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);
                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 17);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 24);
              }
            }
            doc.addImage(ribbin, "PNG", 55, 27, 100, 15);
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(14);
            doc.text("TOP PLAYERS", 88, 33);

            if (toppltype == "2") {
              // //  //// //console.log(topplayers[i])
              // var  t = i +1
              // //  //// //console.log(topplayers[i + 1])
              // //  //// //console.log(topplayers[t])

              var catname = catdata?.filter(
                (ct) => ct.cid == topplayers[plcounter2]?.catid
              )[0]?.cname;
              //  //// //console.log('cat info......')
              //  //// //console.log(topplayers[i + 1])
              //  //// //console.log(catdata)
              //  //// //console.log(catname)
              if (catname) {
                const categoryText = catname.toUpperCase();
                const categoryTextWidth = doc.getTextWidth(categoryText);
                doc.text(
                  categoryText,
                  (doc.internal.pageSize.getWidth() - categoryTextWidth) / 2,
                  24
                );
              }
            }

            if (topnum == 2 || topnum == 3) {
              imageX = 78;
              imageY = 75;
              imagesize = 50;
            } else if (topnum == 4) {
              imageX = 30;
              imageY = 75;
              imagesize = 50;
            } else if (topnum == 5) {
              imageX = 85;
              imageY = 65;
              imagesize = 40;
            } else if (topnum == 6) {
              imageX = 30;
              imageY = 70;
              imagesize = 40;
            } else if (topnum == 7) {
              imageX = 90;
              imageY = 65;
              imagesize = 30;
            } else if (topnum == 8) {
              imageX = 90;
              imageY = 55;
              imagesize = 25;
            } else if (topnum == 9) {
              imageX = 30;
              imageY = 75;
              imagesize = 25;
            } else if (topnum == 10) {
              imageX = 90;
              imageY = 55;
              imagesize = 30;
            } else if (topnum == 11) {
              imageX = 65;
              imageY = 65;
              imagesize = 25;
            } else if (topnum == 12) {
              imageX = 30;
              imageY = 65;
              imagesize = 25;
            } if (topnum == 15) {
              // Fixed: 3-column layout with 5 rows
              imageX = 20;
              imageY = 50;
              imagesize = 35;
            } else if (topnum == 20) {
              // Fixed: 4-column layout with 5 rows
              imageX = 15;
              imageY = 50;
              imagesize = 30;
            }
          }
        }
      });
    }
    doc.save(aid + "-" + acname.toUpperCase() + "_TOP-PLIST.pdf");
  };
  // var sizeX=200;
  // var sizeY=220;
  // var ratio=0.5;
  const handleCheckboxChange = (index) => {
    const selectedIndex = selectedpllist.indexOf(index);
    if (selectedIndex === -1) {
      setselectedpllist([...selectedpllist, index]);
    } else {
      const updatedSelection = [...selectedpllist];
      updatedSelection.splice(selectedIndex, 1);
      setselectedpllist(updatedSelection);
    }
    // //  //// //console.log(selectedcats)
  };
  const plwisepdf = () => {
    var doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [200, 220],
    });
    var soldcount = 0;
    data.list.map((ele, i) => {
      doc.addImage(
        plbg,
        "JPEG",
        1,
        1,
        doc.internal.pageSize.width - 2,
        doc.internal.pageSize.height - 2
      );
      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], "JPEG", 10, 10, 40, 40);
        doc.addImage(aucteambase64[0], "JPEG", 150, 10, 40, 40);
        // //  //// //console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")
      } else {
        doc.addImage(auctiondefaultLogo, "JPEG", 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, "JPEG", 150, 10, 40, 40);
      }
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(149.5, 9.5, 41, 41);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(171, 212, 208); // RGB values for blue
      doc.roundedRect(60, 65, 75, 75, 2, 2, "F"); // 'F' stands for 'fill'
      doc.rect(15, 159, 125, 15, "F"); // 'F' stands for 'fill'

      doc.setTextColor(31, 29, 122); // Set text color to red
      let plen = ele.pname.length * 4;
      doc.text(ele.pname.toUpperCase(), 62.5 - plen / 2 + 15, 169);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(15, 174, 125, 15, "F"); // 'F' stands for 'fill'

      doc.rect(140, 149, 43, 43, "F");
      // doc.roundedRect(140, 149, 43, 43, 5, 5);
      doc.clip();
      if (parseInt(ele.tmid) > 0) {
        if (aucteambase64[ele.tmid]) {
          doc.addImage(aucteambase64[ele.tmid], "JPEG", 141, 150, 41, 41);
        } else {
          doc.addImage(teamdefaultLogo, "JPEG", 141, 150, 41, 41);
        }
      }
      if (
        playerImagesBase64 &&
        playerImagesBase64[ele.pid] &&
        playerImagesBase64[ele.pid].startsWith("data:image")
      ) {
        doc.addImage(playerImagesBase64[ele.pid], "JPEG", 61, 66, 73, 73);
      } else {
        doc.addImage(playerdefaultLogo, "JPEG", 61, 66, 73, 73);
      }
      // doc.addImage(playerdefaultLogo, 'JPEG', 141, 150, 41, 41);

      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");

      doc.text("WILL PLAY FOR ", 65, 182);
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");

      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(1, 204, 198, 15, "F"); // 'F' stands for 'fill'

      doc.setFontSize(18);
      let alen = acname.length * 4;
      doc.setFont("helvetica", "bold");

      doc.text(acname.toUpperCase(), 100 - alen / 2, 213);

      doc.addPage();
      if (ele.tmid > 0) {
        soldcount += 1;
      }
    });
    if (soldcount > 0) {
      doc.save(aid + "-" + acname.toUpperCase() + "_TOP-PLIST.pdf");
    } else {
      alert("No player sold till now !!");
    }
  };

  function drawArcText(doc, text, centerX, centerY, radius) {
    // Text settings
    doc.setFontSize(8);
    doc.setTextColor("#ffffff");
    doc.setFont("Courier", "normal");

    // Calculate text positioning
    const tlength = text.length / 2;
    const angleOffset = -(Math.PI / 2) * ((tlength + 1) / 14); // Start from top of circle
    const falselength = 26; // Fixed length for consistent arc

    // Draw each character along the arc
    for (let i = 0; i < text.length; i++) {
      const rta = (tlength - 0.5 - i) * 7; // Rotation angle for each character
      const char = text[i];
      const angle =
        angleOffset + (i - (falselength - 1) / 2) * (Math.PI / falselength);
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);
      doc.text(char, x, y, null, rta);
    }
  }

  // Also add the getTagName helper function
  function getTagName(ownertag) {
    switch (ownertag) {
      case "1":
        return "Owner";
      case "2":
        return "Co-owner";
      case "3":
        return "Captain";
      case "4":
        return "Icon";
      case "5":
        return "Retain";
      case "6":
        return "V.Captain";
      default:
        return "";
    }
  }
  useEffect(() => {
    // Fetch aucmoredetail if not present
    if (!aucmoredetail || aucmoredetail === 0) {
      const fetchAucDetail = async () => {
        const aid = localStorage.getItem("auction_id");
        const cid = loginuser["cid"];
        const token = loginuser["token"];
        let hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([
              { cid: cid, aid: aid, token: token },
            ]),
          },
        };
        let val = {};
        try {
          const res = await DataService.aucdetail(val, hdr);
          const response = res.data;
          if (response.success === true) {
            dispatch(actmore(response.data));
            setextra(response.data.extra);
          } else {
            if (response.msg) toast.error(response.msg, { theme: "colored" });
          }
        } catch (err) {
          toast.error("Failed to fetch auction detail", { theme: "colored" });
        }
      };
      fetchAucDetail();
    }
  }, [aucmoredetail, dispatch, loginuser]);
  return (
    <>
      <LoadingOverlay
        active={isActive || isbase64Loading}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        {/* <button onClick={generatePDF}>Generate PDF</button>
            <div id="content-to-pdf">
                <h1>Hello, this is HTML content with an image</h1>
                <img src={aucteambase64[0]} style={{ maxWidth: '100%', height: 'auto' }} alt="Example Image" />
            </div> */}
        {pdfclk && (
          <>
            <div className="pdfpopup">
              {/* <FontAwesomeIcon className="pdfclose" onClick={pdfcls} icon={faXmark} /> */}
              <div>
                <div className="pdoptline1">
                  <div className="pdopt1">
                    <select
                      class="form-select"
                      value={orderby2}
                      onChange={(e) => {
                        setorderby2(e.target.value);
                      }}
                      aria-label="Default select example"
                    >
                      <option selected hidden default disabled value="">
                        Page Record
                      </option>
                      <option value="1">ALL</option>
                      <option value="2">Category wise</option>
                      <option value="3">Team wise</option>
                      <option value="4">Top Players</option>
                      <option value="5">Player wise</option>
                      <option value="6">Owners</option>
                    </select>
                  </div>

                  {orderby2 == "2" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={generatecatid}
                        onChange={(e) => {
                          setgeneratecatid(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default value="">
                          Select Category
                        </option>
                        {catdata &&
                          catdata?.map((cat) => {
                            return <option value={cat.cid}>{cat.cname}</option>;
                          })}
                        <option value="0">No category</option>
                      </select>
                    </div>
                  )}
                  {orderby2 == "4" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={toppltype}
                        onChange={(e) => {
                          settoppltype(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          TOP TYPE?
                        </option>
                        <option value="1">All</option>
                        <option value="2">Category wise</option>
                      </select>
                    </div>
                  )}
                  {orderby2 == "4" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={topnum}
                        onChange={(e) => {
                          settopnum(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          TOP ?
                        </option>
                        <option value="1">Top 1</option>
                        <option value="2">Top 2</option>
                        <option value="3">Top 3</option>
                        <option value="4">Top 4</option>
                        <option value="5">Top 5</option>
                        <option value="6">Top 6</option>
                        <option value="7">Top 7</option>
                        <option value="8">Top 8</option>
                        <option value="9">Top 9</option>
                        <option value="10">Top 10</option>
                        <option value="11">Top 11</option>
                        <option value="12">Top 12</option>
                        <option value="15">Top 15</option>
                        <option value="20">Top 20</option>
                      </select>
                    </div>
                  )}
                  {orderby2 == "4" && (
                    <div className="popt3">
                      <select
                        class="form-select"
                        value={toptype}
                        onChange={(e) => {
                          settoptype(e.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option selected default hidden disabled value="">
                          TOP Type
                        </option>
                        <option value="0">On single page</option>
                        <option value="1">Multiple</option>
                      </select>
                    </div>
                  )}

                  {orderby2 !== "4" && orderby2 !== "6" && (
                    <>
                      <div className="pdopt2">
                        <select
                          class="form-select"
                          value={orderby}
                          onChange={(e) => {
                            setorderby(e.target.value);
                          }}
                          aria-label="Default select example"
                        >
                          <option selected hidden default disabled value="">
                            Order By
                          </option>
                          {orderby2 == 1 && (
                            <>
                              <option value="1">Player Number</option>
                              <option value="2">PLayer Name</option>
                              <option value="3">Category</option>
                              <option value="4">Category-Namewise</option>
                            </>
                          )}
                          {orderby2 == 2 && (
                            <>
                              <option value="1">Player Number</option>
                              <option value="2">PLayer Name</option>
                            </>
                          )}
                          {orderby2 == 3 && (
                            <>
                              <option value="5">Sold sequence</option>
                              <option value="6">Category</option>
                              <option value="7">Value</option>
                              <option value="8">PLayer Name</option>
                            </>
                          )}
                        </select>
                      </div>
                      {orderby2 !== "4" && (
                        <div className="popt3">
                          <select
                            class="form-select"
                            value={pdflayouttype}
                            onChange={(e) => {
                              setpdflayouttype(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected default hidden disabled value="">
                              Layout Type
                            </option>
                            <option value="0">Type 1</option>
                            <option value="1">Type 2</option>
                          </select>
                        </div>
                      )}
                      {pdflayouttype == "0" && (
                        <div className="popt3">
                          <select
                            class="form-select"
                            value={colno}
                            onChange={(e) => {
                              setcolno(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected default hidden disabled value="">
                              column
                            </option>
                            <option value="2">Three</option>
                            <option value="1">Two</option>
                          </select>
                        </div>
                      )}
                      <div className="popt4">
                        {colno == 1 && (
                          <select
                            class="form-select"
                            value={numofpl}
                            onChange={(e) => {
                              setnumofpl(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected default hidden disabled value="">
                              Perpage Players
                            </option>
                            <option value={12}>First page-12/Rest-14</option>
                            <option value={14}>First page-14/Rest-16</option>
                            <option value={16}>First page-16/Rest-18</option>
                          </select>
                        )}
                        {colno == 2 && (
                          <select
                            class="form-select"
                            value={numofpl}
                            onChange={(e) => {
                              setnumofpl(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected default hidden disabled value="">
                              Perpage Players
                            </option>
                            <option value={24}>First page-24/Rest-30</option>
                            <option value={27}>First page-27/Rest-33</option>
                            <option value={30}>First page-30/Rest-36</option>
                            <option value={33}>First page-33/Rest-39</option>
                          </select>
                        )}
                      </div>{" "}
                    </>
                  )}
                </div>
                {orderby2 == "4" && (
                  <>
                    <div className="pdoptline2">
                      <div className="pdopt5">
                        <select
                          class="form-select"
                          value={ignoretype}
                          onChange={(e) => {
                            setignoretype(e.target.value);
                          }}
                          aria-label="Default select example"
                        >
                          <option selected hidden default disabled value="">
                            Want to ignore?
                          </option>
                          <option value="retain">Retain</option>
                          <option value="cat">Category</option>
                          <option value="tag">Tag</option>
                          <option value="plno">Player Number</option>
                        </select>
                      </div>
                      {ignoretype == "cat" && (
                        <div className="pdopt5">
                          <select
                            class="form-select"
                            value={ignorecat}
                            onChange={(e) => {
                              setignorecat(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected default value="">
                              select category
                            </option>
                            {catdata &&
                              catdata?.map((cat) => {
                                return (
                                  <option value={cat.cid}>{cat.cname}</option>
                                );
                              })}
                          </select>
                        </div>
                      )}
                      {ignoretype == "tag" && (
                        <div className="pdopt5">
                          <select
                            class="form-select"
                            value={ignoretag}
                            onChange={(e) => {
                              setignoretag(e.target.value);
                            }}
                            aria-label="Default select example"
                          >
                            <option selected hidden default disabled value="">
                              select Tag
                            </option>
                            <option value="0" selected>
                              Select tag
                            </option>
                            <option value="1">Owner</option>
                            <option value="2">Co-owner</option>
                            <option value="3">Captain</option>
                            <option value="4">Icon</option>
                            <option value="5">Retain</option>
                          </select>
                        </div>
                      )}
                    </div>
                    {ignoretype == "plno" && (
                      <div className="pdopt5">
                        <div>Comma separated player number. Ex: 25,50,30</div>

                        <input
                          type="text"
                          placeholder="Enter Player numbers"
                          value={ignoreplnos}
                          onChange={(e) => setignoreplnos(e.target.value)}
                        />
                      </div>
                    )}
                  </>
                )}
                {orderby2 != "4" && orderby2 != "6" && (
                  <>
                    <div className="pdoptline2">
                      <div className="pdopt5">
                        <select
                          class="form-select"
                          value={sts}
                          onChange={(e) => {
                            setsts(e.target.value);
                          }}
                          aria-label="Default select example"
                        >
                          <option selected hidden default disabled value="">
                            status
                          </option>
                          <option value="1">ALL</option>
                          <option value="2">Available</option>
                          <option value="3">Sold</option>
                          <option value="4">Unsold</option>
                          <option value="5">Unsold + available</option>
                          <option value="6">Available + unsold</option>
                        </select>
                      </div>

                      {/* <div> */}
                      {pdflayouttype != "1" && (
                        <div className="setdataopt">
                          <button className="setdata" onClick={setdata}>
                            Manage more data
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="pdoptline2">
                      {issetdata && (
                        <>
                          <div className="showopt">
                            <div className="showoptline">
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisplnoshow(e.target.checked)
                                  }
                                  checked={isplnoshow}
                                  id="flexCheckDefault1"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault1"
                                >
                                  Show player Number
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setispointsshow(e.target.checked)
                                  }
                                  checked={ispointsshow}
                                  id="flexCheckDefault2"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault2"
                                >
                                  Show points
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setiscatshow(e.target.checked)
                                  }
                                  checked={iscatshow}
                                  id="flexCheckDefault5"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault5"
                                >
                                  Show category
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisspnshow(e.target.checked)
                                  }
                                  checked={isspnshow}
                                  id="flexCheckDefault6"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault6"
                                >
                                  Show Sponsor
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisnocatshow(e.target.checked)
                                  }
                                  checked={isnocatshow}
                                  id="flexCheckDefault66"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault66"
                                >
                                  Show No category
                                </label>
                              </div>
                            </div>
                            <div className="showoptline">
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setismobnoshow(e.target.checked)
                                  }
                                  checked={ismobnoshow}
                                  id="flexCheckDefault3"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault3"
                                >
                                  Show mobile Number
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setistshirtshow(e.target.checked)
                                  }
                                  checked={istshirtshow}
                                  id="flexCheckDefault4"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault4"
                                >
                                  Show Tshirt size
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisbasePriceShow(e.target.checked)
                                  }
                                  checked={isbasePriceShow}
                                  id="flexCheckDefault11"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault11"
                                >
                                  Show Base price
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisvalshow(e.target.checked)
                                  }
                                  checked={isvalshow}
                                  id="flexCheckDefault10"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault10"
                                >
                                  Show value
                                </label>
                              </div>
                            </div>
                            <div className="showoptline">
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) => setisspec1(e.target.checked)}
                                  checked={isspec1}
                                  id="flexCheckDefault7"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault7"
                                >
                                  Show spec_1
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) => setisspec2(e.target.checked)}
                                  checked={isspec2}
                                  id="flexCheckDefault8"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault8"
                                >
                                  Show spec_2
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) => setisspec3(e.target.checked)}
                                  checked={isspec3}
                                  id="flexCheckDefault9"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault9"
                                >
                                  Show spec_3
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisownershow(e.target.checked)
                                  }
                                  checked={isownershow}
                                  id="flexCheckDefault13"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault13"
                                >
                                  Show owner
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="check1"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setisdetailshow(e.target.checked)
                                  }
                                  checked={isdetailshow}
                                  id="flexCheckDefault14"
                                />
                                <label
                                  class="form-check-label checklabel"
                                  for="flexCheckDefault14"
                                >
                                  Show detail
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
                {orderby2 == "6" && (
                  <>
                    <div className="tagoptioncontainer">
                      <div>
                        <input
                          type="checkbox"
                          id="ownertag"
                          checked={isownertagselect}
                          onChange={(e) =>
                            setisownertagselect(e.target.checked)
                          }
                        />
                        <label htmlFor="ownertag">Owner</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="co-owner"
                          checked={iscoownertagselect}
                          onChange={(e) =>
                            setiscoownertagselect(e.target.checked)
                          }
                        />
                        <label htmlFor="co-owner">Co-Owner</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="captain"
                          checked={iscaptaintagselect}
                          onChange={(e) =>
                            setiscaptaintagselect(e.target.checked)
                          }
                        />
                        <label htmlFor="captain">Captain</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="vicecaptain"
                          checked={isvicecaptaintagselect}
                          onChange={(e) =>
                            setisvicecaptaintagselect(e.target.checked)
                          }
                        />
                        <label htmlFor="vicecaptain">Vice Captain</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="icon"
                          checked={isicontagselect}
                          onChange={(e) => setisicontagselect(e.target.checked)}
                        />
                        <label htmlFor="icon">Icon</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="retain"
                          checked={isretaintagselect}
                          onChange={(e) =>
                            setisretaintagselect(e.target.checked)
                          }
                        />
                        <label htmlFor="retain">Retain</label>
                      </div>
                    </div>
                  </>
                )}

                <button className="btn btn-primary pdclose" onClick={pdfcls}>
                  Close
                </button>
                <button
                  className="btn btn-primary pddwn"
                  onClick={() => {
                    // Now call the appropriate download function
                    if (orderby2 == "6") {
                      tagwisedownload();
                    } else if (orderby2 == "4") {
                      toppdfdownload();
                    } else if (orderby2 == "5") {
                      plwisepdf();
                    } else {
                      pdfdownload();
                    }
                  }}
                >
                  Download PDF
                </button>
              </div>
              {pdflayouttype !== "" && orderby2 !== "4" && orderby2 !== "5" && (
                <div className="layoutdemodiv">
                  LAYOUT
                  <div>
                    <img
                      src={pdflayouttype == "0" ? pdflayout1 : pdflayout2}
                      className="pdflayoutimg"
                      alt=""
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {isexcelclk && (
          <>
            <div className="pdfdiv"></div>
            <div className="pdfpopup excelpopup">
              <div className="pdoptline1">
                <div className="pdopt1">
                  <select
                    class="form-select"
                    value={exceltype}
                    onChange={(e) => {
                      setexceltype(e.target.value);
                    }}
                    aria-label="Default select example"
                  >
                    <option selected hidden default disabled value="">
                      Excel Type
                    </option>
                    <option value="1">Normal Excel</option>
                    <option value="2">For unsold</option>
                    <option value="3">Final Excel</option>
                    {/* <option value="3">Team wise</option> */}
                  </select>
                </div>

                {/* <div className="popt3">
                  <select class="form-select" value={colno} onChange={(e) => { setcolno(e.target.value) }} aria-label="Default select example">
                    <option selected default hidden disabled value="">column</option>
                    <option value="1">Two</option>
                    <option value="2">Three</option>
                  </select>
                </div>
                <div className="popt4">

                  {
                    colno == 1 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={12}>First page-12/Rest-14</option>
                      <option value={14}>First page-14/Rest-16</option>
                      <option value={16}>First page-16/Rest-18</option>
                    </select>
                  }
                  {
                    colno == 2 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={24}>First page-24/Rest-30</option>
                      <option value={27}>First page-27/Rest-33</option>
                      <option value={30}>First page-30/Rest-36</option>
                      <option value={33}>First page-33/Rest-39</option>
                    </select>
                  }
                </div> */}
                <div className="setdataopt">
                  <button
                    className="setdata"
                    onClick={() => setisexcelmore(!isexcelmore)}
                  >
                    Manage more data
                  </button>
                </div>
              </div>
              {isexcelmore && (
                <>
                  <div className="showopt-scroll-container">
                    <div className="showopt">
                      <div className="showoptline">


                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelplno(e.target.checked)}
                            checked={isexcelplno}
                            id="flexCheckDefault1"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault1"
                          >
                            Show player Number
                          </label>
                        </div>

                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelcat(e.target.checked)}
                            checked={isexcelcat}
                            id="flexCheckDefault5"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault5"
                          >
                            Show category
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelage(e.target.checked)}
                            checked={isexcelage}
                            id="flexCheckDefault5"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault5"
                          >
                            Show age
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexceldob(e.target.checked)}
                            checked={isexceldob}
                            id="flexCheckDefault5"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault5"
                          >
                            Show Dob
                          </label>
                        </div>

                        {exceltype == 3 && (
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) => setisexcelteam(e.target.checked)}
                              checked={isexcelteam}
                              id="flexCheckDefault2"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault2"
                            >
                              Show Teams
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelmob(e.target.checked)}
                            checked={isexcelmob}
                            id="flexCheckDefault3"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault3"
                          >
                            Show mobile Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelfname(e.target.checked)}
                            checked={isexcelfname}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Fname
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisisexceldetail(e.target.checked)}
                            checked={isexceldetail}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Detail
                          </label>
                        </div>
                        {(() => {
                          // Collect all unique custom fields from ALL players (not just first player)
                          const allFieldsMap = new Map(); // Use Map to preserve order and avoid duplicates
                          
                          if (data?.list && data.list.length > 0) {
                            data.list.forEach((player) => {
                              if (player.runwkt && player.runwkt !== null && player.runwkt !== "" && player.runwkt !== "null") {
                                try {
                                  const parsed = JSON.parse(player.runwkt);
                                  let runwktArray = [];
                                  
                                  if (Array.isArray(parsed)) {
                                    runwktArray = parsed;
                                  } else if (typeof parsed === 'object' && parsed !== null) {
                                    // Convert object format to array format for processing
                                    runwktArray = Object.values(parsed).filter(item => item && item.N);
                                  }
                                  
                                  // Process each field
                                  runwktArray.forEach((item) => {
                                    const fieldName = item?.N?.trim();
                                    if (!fieldName) return;
                                    
                                    // If field not already in map, add it
                                    if (!allFieldsMap.has(fieldName)) {
                                      allFieldsMap.set(fieldName, item);
                                    }
                                  });
                                } catch (e) {
                                  console.error("runwkt parse error for player:", e);
                                }
                              }
                            });
                          }
                          
                          // Convert Map to array for rendering
                          const allFields = Array.from(allFieldsMap.values());
                          
                          if (allFields.length === 0) return null;
                          
                          return (
                            <div className="showoptline">
                              {allFields.map((item, index) => {
                                const fieldName = item.N.trim();
                                const safeKey = `custom_${index}_${fieldName.replace(/\s+/g, '_')}`;

                                return (
                                  <div className="form-check" key={safeKey}>
                                    <input
                                      className="check1"
                                      type="checkbox"
                                      id={safeKey}
                                      checked={dynamicRunwktFields[fieldName] ?? true}
                                      onChange={(e) =>
                                        setDynamicRunwktFields(prev => ({
                                          ...prev,
                                          [fieldName]: e.target.checked
                                        }))
                                      }
                                    />
                                    <label className="form-check-label checklabel" htmlFor={safeKey}>
                                      Show {fieldName}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })()}
                        {exceltype == 3 && (
                          <div class="form-check">
                            <input
                              class="check1"
                              type="checkbox"
                              onChange={(e) => setisexcelpoints(e.target.checked)}
                              checked={isexcelpoints}
                              id="flexCheckDefault2"
                            />
                            <label
                              class="form-check-label checklabel"
                              for="flexCheckDefault2"
                            >
                              Show points
                            </label>
                          </div>
                        )}

                        {/* {exceltype==3 && <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>} */}
                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexceltshirt(e.target.checked)}
                            checked={isexceltshirt}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Tshirt size
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexceltrouser(e.target.checked)}
                            checked={isexceltrouser}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Trouser size
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexceljname(e.target.checked)}
                            checked={isexceljname}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Jersey Name
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexceljno(e.target.checked)}
                            checked={isexceljno}
                            id="flexCheckDefault4"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault4"
                          >
                            Show Jersey Number
                          </label>
                        </div>
                      </div>

                      <div className="showoptline">
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelsp1(e.target.checked)}
                            checked={isexcelsp1}
                            id="flexCheckDefault7"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault7"
                          >
                            Show spec_1
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelsp2(e.target.checked)}
                            checked={isexcelsp2}
                            id="flexCheckDefault8"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault8"
                          >
                            Show spec_2
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelsp3(e.target.checked)}
                            checked={isexcelsp3}
                            id="flexCheckDefault9"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault9"
                          >
                            Show spec_3
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelimage(e.target.checked)}
                            checked={isexcelimage}
                            id="flexCheckDefault15"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault15"
                          >
                            Show Image Link
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="check1"
                            type="checkbox"
                            onChange={(e) => setisexcelbasebid(e.target.checked)}
                            checked={isexcelbasebid}
                            id="flexCheckDefault9"
                          />
                          <label
                            class="form-check-label checklabel"
                            for="flexCheckDefault9"
                          >
                            Show BaseBid
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* <div className="pdoptline2">
                <div className="pdopt5">
                  <select class="form-select" value={sts} onChange={(e) => { setsts(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">status</option>
                    <option value="1">ALL</option>
                    <option value="2">Available</option>
                    <option value="3">Sold</option>
                  </select>
                </div>

                <div className="setdataopt">
                  <button className="setdata" onClick={setdata}>Manage more data</button>

                </div>
              </div>
              <div className="pdoptline2">
                {issetdata &&
                  <>
                    <div className="showopt">
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisplnoshow(e.target.checked)} checked={isplnoshow} id="flexCheckDefault1" />
                          <label class="form-check-label checklabel" for="flexCheckDefault1">
                            Show player Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setispointsshow(e.target.checked)} checked={ispointsshow} id="flexCheckDefault2" />
                          <label class="form-check-label checklabel" for="flexCheckDefault2">
                            Show points
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setiscatshow(e.target.checked)} checked={iscatshow} id="flexCheckDefault5" />
                          <label class="form-check-label checklabel" for="flexCheckDefault5">
                            Show category
                          </label>
                        </div>
                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setismobnoshow(e.target.checked)} checked={ismobnoshow} id="flexCheckDefault3" />
                          <label class="form-check-label checklabel" for="flexCheckDefault3">
                            Show mobile Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setistshirtshow(e.target.checked)} checked={istshirtshow} id="flexCheckDefault4" />
                          <label class="form-check-label checklabel" for="flexCheckDefault4">
                            Show Tshirt size
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>

                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec1(e.target.checked)} checked={isspec1} id="flexCheckDefault7" />
                          <label class="form-check-label checklabel" for="flexCheckDefault7">
                            Show spec_1
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec2(e.target.checked)} checked={isspec2} id="flexCheckDefault8" />
                          <label class="form-check-label checklabel" for="flexCheckDefault8">
                            Show spec_2
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec3(e.target.checked)} checked={isspec3} id="flexCheckDefault9" />
                          <label class="form-check-label checklabel" for="flexCheckDefault9">
                            Show spec_3
                          </label>
                        </div>

                      </div>
                    </div>
                  </>
                }
              </div> */}

              <button className="btn btn-primary pdclose" onClick={excelcls}>
                Close
              </button>
              <button className="btn btn-primary pddwn" onClick={exceldownload}>
                Download Excel
              </button>
            </div>
          </>
        )}
        <div>
          <Navigationtitle data={match} />
          {/* {  <div>
            player 1 
            <img src={base64Images[0]} alt="kkmk" />
          </div>} */}
          {/* <button></button> */}
          {pdfDataUri && (
            <iframe
              title="Player Cards PDF"
              src={pdfDataUri}
              width="100%"
              height="500"
              style={{ border: "none" }}
            />
          )}
          {/* <Document>
            <Page size="A4">
              <View style={styles.imageContainer}>
                <ClipPath id="myClipPath">
                  {createClippingPath(200, 200, radius)}
                </ClipPath>
                <Image style={styles.image} src={auclogopath + auclogo + '?c'} clipPath="url(#myClipPath)" />
              </View>
            </Page>
          </Document> */}

          {/* <div  className={`bulkdelenable ${isbulkdelenable && 'bulkenable'}`} onClick={()=>setisbulkdelenable(prev=>!prev)}><TiUserDelete /></div> */}
          {/* <button className="btn btn-primary getfinalexcel " onClick={excelclk}>Excel</button> */}
          {/* <Link to={'/players-pdf'}> <button className="btn btn-primary base64 " >base64</button></Link> */}
          {/* <button onClick={() => base64()} className="btn btn-primary base64 " >base64</button> */}
          {/* {//  //// //console.log("ffffffffffffffffffffffffffffff")}
          {//  //// //console.log(auclogopath + auclogo)} */}
          <img
            ref={(img) => {
              aucteamrefs.current["0"] = img;
              handleaucimgload(0);
            }}
            style={{ display: "none" }}
            onLoad={handleaucimgload(0)}
            fallback={<Shimmer width={"100%"} height={"auto"} />}
            src={auclogopath + auclogo + "?c"}
            alt="base img"
            crossOrigin="Anonymous"
          />
          <img
            ref={(img) => {
              aucteamrefs.current["1"] = img;
              handleaucimgload(1);
            }}
            style={{ display: "none" }}
            onLoad={handleaucimgload(1)}
            fallback={<Shimmer width={"100%"} height={"auto"} />}
            src={sponsorlogo}
            crossOrigin="Anonymous"
            alt="base img"
          />
          <img
            ref={(img) => {
              aucteamrefs.current["2"] = img;
              handleaucimgload(2);
            }}
            style={{ display: "none" }}
            onLoad={handleaucimgload(2)}
            fallback={<Shimmer width={"100%"} height={"auto"} />}
            src={cusbg}
            crossOrigin="Anonymous"
            alt="base img"
          />
          <img
            ref={(img) => {
              pldefault.current["0"] = img;
              // handlepldefaultload(0)
            }}
            style={{ display: "none" }}
            // onLoad={handlepldefaultload(0)}
            fallback={<Shimmer width={"100%"} height={"auto"} />}
            src={playerdefaultLogo}
            alt="base img"
            crossOrigin="Anonymous"
          />

          {dataTeam != "" &&
            dataTeam.map((ele) => {
              // //  //// //console.log("team se related")
              // //  //// //console.log(ele)
              return (
                <img
                  style={{ display: "none" }}
                  src={teampath + ele.logo + "?c"}
                  ref={(img) => {
                    aucteamrefs.current[ele.tid] = img;
                    handleaucimgload(ele.tid);
                  }}
                  onLoad={handleaucimgload(ele.tid)}
                  alt="base img"
                  crossOrigin="Anonymous"
                />
              );
            })}
          <div id="top-categories" className="top-cat-area  bottom-less">
            <div className="container-fluid padding-left-0px">
              <section
                id="advisor"
                className="advisor-area default-padding bottom-less"
              >
                <div className="container-fluid ">
                  {/* <img src="https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg" ref={yourImageRef} alt="" /> */}

                  {/* <img src={base64Images[6]} alt="pl image" /> */}

                  <div className="row">
                    <div className="plheader">
                      <div className="plfilters" onKeyDown={onKeyDownHandler}>
                        <input
                          className="form-control"
                          placeholder="Pl.No / Name / Mob.No"
                          type="text"
                          name="searchText"
                          value={filter.searchText}
                          onChange={handleFilterChange}
                        />
                        <select
                          class="form-select"
                          name="selectedStatus"
                          value={filter.selectedStatus}
                          onChange={handleFilterChange}
                          aria-label="Default select example"
                        >
                          <option selected default disabled hidden value="">
                            Status
                          </option>

                          <option value="1">ALL</option>
                          <option value="2">Available</option>
                          <option value="3">Sold</option>
                          <option value="4">Freezed</option>
                          <option value="5">Unold</option>
                          <option value="6">Owners</option>
                        </select>
                        <select
                          class="form-select"
                          name="selectedCategory"
                          value={filter.selectedCategory}
                          onChange={handleFilterChange}
                          aria-label="Default select example"
                        >
                          <option selected default value="1">
                            Category(ALL)
                          </option>

                          {catdata !== "" &&
                            catdata?.map((ct) => (
                              <option value={ct.cid} key={ct.cid}>
                                {ct.cname}
                              </option>
                            ))}
                        </select>
                        <select
                          class="form-select"
                          value={filorder}
                          onChange={(e) => {
                            setorderdata(e.target.value);
                          }}
                          aria-label="Default select example"
                        >
                          <option selected default disabled hidden value="">
                            Order By
                          </option>

                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>
                        </select>
                      </div>

                      <div className="plbuttons">
                        <div>
                          {" "}
                          <button
                            className="btn btn-primary pl-btn "
                            onClick={gotoimport}
                          >
                            Import Players
                          </button>{" "}
                        </div>
                        <div>
                          <button
                            className="btn btn-primary  pl-btn"
                            onClick={getpdf}
                          >
                            PDF
                          </button>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary pl-btn"
                            onClick={excelclk}
                          >
                            Excel
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* {pldata?.map((ele) => {
                      return (<div className="testingpdf" ref={reportTemplateRef}>
                        <div className="testingpdf2">

                          <img src={playerdefaultLogo} alt="" />
                        </div>
                        <div className="parent" >
                          <p > This is player...</p>
                          <></>


                        </div>
                      </div>)
                    })} */}
                    <div>
                      {/* <button onClick={() => handleGeneratePdf()}>Generate PDF</button> */}
                    </div>

                    {/* Display duplicate player codes error message */}
                    <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", margin: "10px 0" }}>
                      {/* 1. Duplicate Name + Mobile */}
                      {/* 1. Duplicate Name + Mobile */}
                      {duplicateNameAndMobile.length > 0 && (
                        <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                          {(() => {

                            const count = duplicateNameAndMobile.length;

                            return (
                              <div
                                className="duplicate-error-container"
                                style={{
                                  backgroundColor: "#ffebee",
                                  color: "#d32f2f",
                                  padding: "12px 15px",
                                  borderRadius: "4px",
                                  borderLeft: "6px solid #c62828",
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                                onClick={() => setExpanded(!expanded)}
                              >
                                <div style={{ fontWeight: "bold", fontSize: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                  <span>⚠️ {count} Duplicate Player(Name + Mobile)</span>
                                  <span style={{ fontSize: "20px" }}>{expanded ? "−" : "+"}</span>
                                </div>

                                <div
                                  style={{
                                    maxHeight: expanded ? "1000px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.4s ease",
                                    paddingTop: expanded ? "10px" : "0",
                                  }}
                                >
                                  <div style={{ fontSize: "15px", lineHeight: "1.6" }}>
                                    {duplicateNameAndMobile.map((item, index) => (
                                      <div
                                        key={index}
                                        style={{ color: "#b71c1c", cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDuplicateClick(item.pname);
                                        }}
                                        title="Click to filter by this name"
                                      >
                                        → {item.pname} ({item.mobile})
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      )}

                      {/* 2. Duplicate Player Codes */}
                      {duplicatePcodes.length > 0 && (
                        <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                          {(() => {

                            const count = duplicatePcodes.length;


                            return (
                              <div
                                className="duplicate-error-container"
                                style={{
                                  backgroundColor: "#ffebee",
                                  color: "#d32f2f",
                                  padding: "12px 15px",
                                  borderRadius: "4px",
                                  borderLeft: "4px solid #d32f2f",
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                                onClick={() => setExpanded(!expanded)}
                              >
                                <div style={{ fontWeight: "bold", fontSize: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                  <span>⚠️ {duplicatePcodes.length} Duplicate Player Code</span>
                                  <span style={{ fontSize: "20px" }}>{expanded ? "−" : "+"}</span>
                                </div>

                                <div
                                  style={{
                                    maxHeight: expanded ? "1000px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.4s ease",
                                    paddingTop: expanded ? "10px" : "0",
                                  }}
                                >
                                  <div style={{ fontSize: "15px" }}>
                                    {duplicatePcodes.map((code, index) => (
                                      <span
                                        key={index}
                                        style={{ cursor: "pointer", textDecoration: "underline", marginRight: "10px", display: "inline-block" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDuplicateClick(code.toString());
                                        }}
                                        title="Click to filter by this code"
                                      >
                                        {code}{index < duplicatePcodes.length - 1 ? "," : ""}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      )}

                      {/* 3. Duplicate Mobile Numbers */}
                      {duplicateMobiles.length > 0 && (
                        <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                          {(() => {

                            const count = duplicateMobiles.length;
                            return (
                              <div
                                className="duplicate-error-container"
                                style={{
                                  backgroundColor: "#fef6c2",
                                  color: "#646706",
                                  padding: "12px 15px",
                                  borderRadius: "4px",
                                  borderLeft: "4px solid #fff702",
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                                onClick={() => setExpanded(!expanded)}
                              >
                                <div style={{ fontWeight: "bold", fontSize: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                  <span>⚠️ {count} Duplicate Mobile Number</span>
                                  <span style={{ fontSize: "20px" }}>{expanded ? "−" : "+"}</span>
                                </div>

                                <div
                                  style={{
                                    maxHeight: expanded ? "1000px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.4s ease",
                                    paddingTop: expanded ? "10px" : "0",
                                  }}
                                >
                                  <div style={{ fontSize: "15px" }}>
                                    {duplicateMobiles.map((mobile, index) => (
                                      <span
                                        key={index}
                                        style={{ cursor: "pointer", textDecoration: "underline", marginRight: "10px", display: "inline-block" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDuplicateClick(mobile.toString());
                                        }}
                                        title="Click to filter by this mobile"
                                      >
                                        {mobile}{index < duplicateMobiles.length - 1 ? "," : ""}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </div>

                    <div className="advisor-items text-center text-light pl-container">
                      <h4 className="plcount"> {data?.list?.length} PLAYERS</h4>
                      {data != "" ? (
                        data.list?.map((dt, index) => {
                          // var fgstyle = {
                          //   color: 'none'

                          // }

                          // if (dt.tmid > 0) {

                          //   fgstyle = {
                          //     color: 'red'
                          //   }
                          //   var mytitle = "Sold"
                          // }
                          // else if (dt.isskiped !== "0") {
                          //   fgstyle = {
                          //     color: 'yellow'
                          //   }
                          // }
                          // else if (dt.isnonplay !== "0") {
                          //   fgstyle = {
                          //     color: 'blue'
                          //   }
                          //   var mytitle = "Non Playing"
                          // }
                          var pcolor = "jj";
                          var pbgcolor = "plimgh";
                          var pnumcolor = "plnumber";
                          var soldptsboxclass = "soldptsbox";
                          if (
                            (dt.isskiped && dt.isskiped !== "0") ||
                            dt.tmid > 0 ||
                            dt.isnonplay !== "0"
                          ) {
                            var pcolor = "plred";
                            pbgcolor = "plimgh2";
                            pnumcolor = "plnumber2";
                            soldptsboxclass = "soldptsbox2";
                          } else if (dt.isskiped == 1) {
                            // var pcolor = "plfreeze";
                          }
                          if (dt.isfreez == 1) {
                            var pcolor = "plred plfreeze";
                          }
                          if (dt.tmid == "0" || dt.tmid == "") {
                            var pcolor = "cnormal";
                            pbgcolor = "plimgh";
                          }

                          var morefields = null;
                          if (dt.runwkt != "" && dt.runwkt != null) {
                            var morefields = JSON.parse(dt.runwkt);
                          }
                          // //  //// //console.log('cat data bta')
                          // //  //// //console.log(catdata)
                          if (catdata !== "") {
                            var catname = catdata?.filter(
                              (ct) => ct.cid == dt.catid
                            )[0]?.cname;
                            // //  //// //console.log(catname)
                          }
                          // //// //console.log(dt)
                          //  //// //console.log('tmids')
                          //  //// //console.log(parseInt(dt.tmid))

                          return (
                            <div
                              onMouseEnter={() => setHoveredCard(index)}
                              onMouseLeave={() => setHoveredCard(null)}
                              className="col-md-4 col-sm-6 col-xs-6 single-item padding-10 player-single"
                            >
                              <div
                                style={{ overflow: "visible" }}
                                className="advisor-item"
                              >
                                <div
                                  style={{ overflow: "visible" }}
                                  className="info-box plbox"
                                >
                                  {/* {
                                    (dt.isskiped !== "0" || dt.tmid > 0 || dt.isnonplay !== "0") &&
                                    <FontAwesomeIcon className="fgicon" title={mytitle} style={fgstyle} icon={faFlag} />

                                  } */}

                                  <div className="row mar-right-0">
                                    <div className="col-md-4 col-sm-6   padding-r-0 ">
                                      <div
                                        className={pbgcolor}
                                        // style={{
                                        //   position: "relative",
                                        //   overflow: "visible",
                                        // }}
                                        onMouseEnter={() => setHoveredImg(index)}
                                        onMouseLeave={() => setHoveredImg(null)}
                                      >
                                        <div className={pnumcolor}>
                                          {dt.pcode}
                                        </div>

                                        <img
                                          src={
                                            dt.img == null || dt.img === ""
                                              ? playerdefaultLogo
                                              : data.path + dt.img + "?c"
                                          }
                                          style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "6px",
                                            display: "block"
                                          }}
                                        />

                                        {/* SOLD POINTS */}
                                        {parseInt(dt.tmid) > 0 && (
                                          <div className={soldptsboxclass}>
                                            {parseInt(dt.points).toFixed(currentauc.isdecm)}
                                          </div>
                                        )}

                                        {/* DELETE ON HOVER */}
                                        {hoveredImg === index && dt.img && (
                                          <button
                                            className="delete-img-btn"
                                            onClick={() => handleDeleteImage(dt.pid, aid)}
                                            style={{
                                              position: "absolute",
                                              top: 6,
                                              right: 6,
                                              background: "red",
                                              border: "none",
                                              color: "#fff",
                                              padding: "4px 8px",
                                              fontSize: "12px",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              zIndex: 9999
                                            }}
                                          >
                                            Delete
                                          </button>
                                        )}

                                      </div>


                                      <div className="card-icon player-edit pleditbtns">
                                        {/* <div ><span className="plnumcontainer">22</span></div> */}
                                        <Link
                                          className="edit-icon"
                                          to={
                                            "/edit-auction-player/" +
                                            encode(dt.pid)
                                          }
                                        >
                                          <AiIcons.AiFillEdit></AiIcons.AiFillEdit>
                                        </Link>

                                        <button
                                          type="button"
                                          className="delete-icon"
                                          onClick={() => deldata(dt.pid)}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            padding: 0,
                                            cursor: "pointer",
                                          }}
                                          aria-label="Delete player"
                                        >
                                          <AiIcons.AiFillDelete></AiIcons.AiFillDelete>
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-sm-6 width-full padding-l-0">
                                      <div
                                        className={`info-title player-info p-name ${pcolor}`}
                                      >
                                        {dt.pname}
                                        {dt.isowner > 0 && (
                                          <FontAwesomeIcon
                                            icon={faCrown}
                                            className="f-crown-icon"
                                          />
                                        )}
                                      </div>

                                      <div className="info-title player-info">
                                        <div className="row plin">
                                          {/* <div className="col-md-6 col-xs-12 plcode">
  
                                              {" "}
                                              P.NO.{" "}
                                              {" "}
                                              :<b className="player-info-b">{dt.pcode} </b>
                                            </div> */}

                                          {/* <div className="col-md-6 col-xs-12 ">
                                            Age{" "}
                                            : <b className="player-info-b">{dt.age
                                              //getAge(dt.dob)
                                            }</b>
                                          </div>} */}
                                        </div>

                                        <div className="row spcs">
                                          {dt.age !== "0" &&
                                            dt.age !== "" &&
                                            dt.age !== 0 && (
                                              <div className="info-title player-info col-md-12 ">
                                                Age :{" "}
                                                <b className="player-info-b">
                                                  {
                                                    dt.age
                                                    //getAge(dt.dob)
                                                  }
                                                </b>
                                              </div>
                                            )}
                                          {dt.spcf1 && (
                                            <div className="info-title player-info col-md-12 ">
                                              {dt.spcf1}
                                            </div>
                                          )}

                                          {dt.spcf2 && (
                                            <div className="info-title player-info col-md-12">
                                              {dt.spcf2}
                                            </div>
                                          )}
                                          {/* {dt.spcf3 && <div className="info-title player-info col-md-12">
                                            {dt.spcf3}
                                          </div>} */}
                                          {catname && (
                                            <div className="info-title player-info col-md-12">
                                              From {catname.toUpperCase()}
                                            </div>
                                          )}
                                          {dt.mob && (
                                            <div className="info-title player-info col-md-12">
                                              Mob:{dt.mob}
                                            </div>
                                          )}
                                          {/* {morefields !==null && morefields.map((item,ind)=>{
                                            return (
                                              <div className="info-title player-info col-md-12">
                                              {item['N']} :{item['V']}
                                            </div>
                                            )
                                          })} */}
                                          {morefields !== null &&
                                            Object.entries(morefields).map(
                                              ([key, value]) => {
                                                if (value.V !== "") {
                                                  return (
                                                    <div className="info-title player-info col-md-12">
                                                      {value.N}:{value.V}
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}
                                          <div className="info-title player-info col-md-12"></div>
                                          {parseInt(dt.tmid) > 0 &&
                                            dataTeam != "" && (
                                              <div className="info-title player-info col-md-12 ">
                                                <span className="fz-1">
                                                  {" "}
                                                  Sold to
                                                </span>
                                                <span className="soldteam">
                                                  {" "}
                                                  {dataTeam &&
                                                    dataTeam.filter(
                                                      (ele) =>
                                                        ele.tid == dt.tmid
                                                    )[0]?.name}
                                                </span>
                                              </div>
                                            )}
                                          {/* {// //console.log('receiptList')}
                                          {// //console.log(receiptList)} */}
                                          {receiptList &&
                                            receiptList.length > 0 &&
                                            receiptList.find(
                                              (receipt) =>
                                                receipt.pid === dt.pid
                                            ) && (
                                              <div className="info-title player-info col-md-12">
                                                <button
                                                  onClick={() => {
                                                    const receipt =
                                                      receiptList.find(
                                                        (receipt) =>
                                                          receipt.pid === dt.pid
                                                      );
                                                    setSelectedReceipt(
                                                      receiptpath +
                                                      receipt.photo
                                                    );
                                                    setShowReceiptModal(true);
                                                  }}
                                                  style={{
                                                    background: "#4CAF50",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "5px 10px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  <AiIcons.AiOutlineFileImage
                                                    style={{
                                                      marginRight: "5px",
                                                    }}
                                                  />
                                                  View{" "}
                                                  {aucmoredetail?.show?.receipt
                                                    ?.label || "Receipt"}
                                                </button>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div className="delinpselect">  {(hoveredCard == index || selectedpllist.includes(dt.pid)) && <>   <input type="checkbox" className='catcheck' checked={selectedpllist.includes(dt.pid)} onChange={() => handleCheckboxChange(dt.pid)} />
                                    </>} 
                                     </div> */}
                                    {/* <div className={badg}>Sold</div> */}
                                    {/* {
                                      dt.isfreez == 1 && <div className="badge2"></div>
                                    } */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <button
                          onClick={() => {
                            history.push("add-auction-player");
                          }}
                          className="customaddbtn"
                        >
                          Add Player
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
      {showReceiptModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowReceiptModal(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "90%",
              maxHeight: "90%",
              overflow: "auto",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={() => setShowReceiptModal(false)}
            >
              &times;
            </button>
            <h3 style={{ marginBottom: "15px", textAlign: "center" }}>
              Receipt
            </h3>
            <div style={{ textAlign: "center" }}>
              <img
                src={selectedReceipt}
                alt="Receipt"
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Players;


